// Hand-maintained from https://api.dev.omnetic.dev/dms/v1/doc/new_vehicle.json (OpenAPI group new_vehicle).
// Every endpoint omits the Authorization parameter (the base query injects the user token), except applyImporterStatus, which forwards an explicit service JWT for ESB callers.
import {omneticApi as api} from '../../../../base/src/baseApi/omneticApi';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    archiveColour: build.mutation<ArchiveColourApiResponse, ArchiveColourApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/colour/${queryArg.colourId}`,
        method: 'DELETE',
        body: queryArg.pricedItemArchiveRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getColour: build.query<GetColourApiResponse, GetColourApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/colour/${queryArg.colourId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateColour: build.mutation<UpdateColourApiResponse, UpdateColourApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/colour/${queryArg.colourId}`,
        method: 'PATCH',
        body: queryArg.colourWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createColour: build.mutation<CreateColourApiResponse, CreateColourApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/colour`,
        method: 'POST',
        body: queryArg.colourWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listColour: build.query<ListColourApiResponse, ListColourApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/colour`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    putColourTrims: build.mutation<PutColourTrimsApiResponse, PutColourTrimsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/colour/${queryArg.colourId}/trim`,
        method: 'PUT',
        body: queryArg.replaceColourTrimsRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getColourUpholsteryRestrictions: build.query<
      GetColourUpholsteryRestrictionsApiResponse,
      GetColourUpholsteryRestrictionsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/colour-upholstery-restriction`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    putColourUpholsteryRestrictions: build.mutation<
      PutColourUpholsteryRestrictionsApiResponse,
      PutColourUpholsteryRestrictionsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/colour-upholstery-restriction`,
        method: 'PUT',
        body: queryArg.replaceColourUpholsteryRestrictionsRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archiveEngine: build.mutation<ArchiveEngineApiResponse, ArchiveEngineApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/engine/${queryArg.engineId}`,
        method: 'DELETE',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getEngine: build.query<GetEngineApiResponse, GetEngineApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/engine/${queryArg.engineId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateEngine: build.mutation<UpdateEngineApiResponse, UpdateEngineApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/engine/${queryArg.engineId}`,
        method: 'PATCH',
        body: queryArg.engineWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createEngine: build.mutation<CreateEngineApiResponse, CreateEngineApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/engine`,
        method: 'POST',
        body: queryArg.engineWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listEngine: build.query<ListEngineApiResponse, ListEngineApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/engine`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    evaluateAuthorConfiguration: build.query<
      EvaluateAuthorConfigurationApiResponse,
      EvaluateAuthorConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/author-configurator/evaluate`,
        method: 'POST',
        body: queryArg.evaluateAuthorConfigurationRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archiveFeature: build.mutation<ArchiveFeatureApiResponse, ArchiveFeatureApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature/${queryArg.featureId}`,
        method: 'DELETE',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getFeature: build.query<GetFeatureApiResponse, GetFeatureApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature/${queryArg.featureId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateFeature: build.mutation<UpdateFeatureApiResponse, UpdateFeatureApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature/${queryArg.featureId}`,
        method: 'PATCH',
        body: queryArg.featureWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createFeature: build.mutation<CreateFeatureApiResponse, CreateFeatureApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature`,
        method: 'POST',
        body: queryArg.featureWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listFeature: build.query<ListFeatureApiResponse, ListFeatureApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
        params: {
          modelYearId: queryArg.modelYearId,
          search: queryArg.search,
        },
      }),
    }),
    createFeatureRule: build.mutation<CreateFeatureRuleApiResponse, CreateFeatureRuleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature-rule`,
        method: 'POST',
        body: queryArg.featureRuleWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listFeatureRule: build.query<ListFeatureRuleApiResponse, ListFeatureRuleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature-rule`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    deleteFeatureRule: build.mutation<DeleteFeatureRuleApiResponse, DeleteFeatureRuleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature-rule/${queryArg.featureRuleId}`,
        method: 'DELETE',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getFeatureRule: build.query<GetFeatureRuleApiResponse, GetFeatureRuleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature-rule/${queryArg.featureRuleId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateFeatureRule: build.mutation<UpdateFeatureRuleApiResponse, UpdateFeatureRuleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/feature-rule/${queryArg.featureRuleId}`,
        method: 'PATCH',
        body: queryArg.featureRuleWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getAuthorConfiguratorBundle: build.query<
      GetAuthorConfiguratorBundleApiResponse,
      GetAuthorConfiguratorBundleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/author-configurator`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
        params: {
          previewAsConfigurator: queryArg.previewAsConfigurator,
        },
      }),
    }),
    getCatalogueTree: build.query<GetCatalogueTreeApiResponse, GetCatalogueTreeApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/tree`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getConfiguratorBundle: build.query<
      GetConfiguratorBundleApiResponse,
      GetConfiguratorBundleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/configurator`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archiveMake: build.mutation<ArchiveMakeApiResponse, ArchiveMakeApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/make/${queryArg.makeId}`,
        method: 'DELETE',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getMake: build.query<GetMakeApiResponse, GetMakeApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/make/${queryArg.makeId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateMake: build.mutation<UpdateMakeApiResponse, UpdateMakeApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/make/${queryArg.makeId}`,
        method: 'PATCH',
        body: queryArg.makeWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createMake: build.mutation<CreateMakeApiResponse, CreateMakeApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/make`,
        method: 'POST',
        body: queryArg.makeWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listMake: build.query<ListMakeApiResponse, ListMakeApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/make`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getMakeOrderStatusMapping: build.query<
      GetMakeOrderStatusMappingApiResponse,
      GetMakeOrderStatusMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/make/${queryArg.makeId}/order-status-mapping`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getMakeOrderStatusSignalMapping: build.query<
      GetMakeOrderStatusSignalMappingApiResponse,
      GetMakeOrderStatusSignalMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/make/${queryArg.makeId}/order-status-signal-mapping`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listUnmappedMakeStatus: build.query<
      ListUnmappedMakeStatusApiResponse,
      ListUnmappedMakeStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/make/${queryArg.makeId}/unmapped-status`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archiveModel: build.mutation<ArchiveModelApiResponse, ArchiveModelApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model/${queryArg.modelId}`,
        method: 'DELETE',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getModel: build.query<GetModelApiResponse, GetModelApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model/${queryArg.modelId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateModel: build.mutation<UpdateModelApiResponse, UpdateModelApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model/${queryArg.modelId}`,
        method: 'PATCH',
        body: queryArg.modelWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createModel: build.mutation<CreateModelApiResponse, CreateModelApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model`,
        method: 'POST',
        body: queryArg.modelWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listModel: build.query<ListModelApiResponse, ListModelApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    uploadModelImage: build.mutation<UploadModelImageApiResponse, UploadModelImageApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model/${queryArg.modelId}/image`,
        method: 'POST',
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archiveModelYear: build.mutation<ArchiveModelYearApiResponse, ArchiveModelYearApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}`,
        method: 'DELETE',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getModelYear: build.query<GetModelYearApiResponse, GetModelYearApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateModelYear: build.mutation<UpdateModelYearApiResponse, UpdateModelYearApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}`,
        method: 'PATCH',
        body: queryArg.modelYearWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createModelYear: build.mutation<CreateModelYearApiResponse, CreateModelYearApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year`,
        method: 'POST',
        body: queryArg.modelYearWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listModelYear: build.query<ListModelYearApiResponse, ListModelYearApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    duplicateModelYear: build.mutation<DuplicateModelYearApiResponse, DuplicateModelYearApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/duplicate`,
        method: 'POST',
        body: queryArg.duplicateModelYearRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getModelYearReadiness: build.query<
      GetModelYearReadinessApiResponse,
      GetModelYearReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/readiness`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    publishModelYear: build.mutation<PublishModelYearApiResponse, PublishModelYearApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/publish`,
        method: 'POST',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    unpublishModelYear: build.mutation<UnpublishModelYearApiResponse, UnpublishModelYearApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/unpublish`,
        method: 'POST',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archivePackage: build.mutation<ArchivePackageApiResponse, ArchivePackageApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/package/${queryArg.packageId}`,
        method: 'DELETE',
        body: queryArg.pricedItemArchiveRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getPackage: build.query<GetPackageApiResponse, GetPackageApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/package/${queryArg.packageId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updatePackage: build.mutation<UpdatePackageApiResponse, UpdatePackageApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/package/${queryArg.packageId}`,
        method: 'PATCH',
        body: queryArg.packageWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createPackage: build.mutation<CreatePackageApiResponse, CreatePackageApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/package`,
        method: 'POST',
        body: queryArg.packageWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listPackage: build.query<ListPackageApiResponse, ListPackageApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/package`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    applyMidYearPriceAdjustment: build.mutation<
      ApplyMidYearPriceAdjustmentApiResponse,
      ApplyMidYearPriceAdjustmentApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/price-adjustment`,
        method: 'POST',
        body: queryArg.priceAdjustmentRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    applyPricedItemChangeBatch: build.mutation<
      ApplyPricedItemChangeBatchApiResponse,
      ApplyPricedItemChangeBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/priced-item-change-batch`,
        method: 'POST',
        body: queryArg.pricedItemChangeBatchRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listPricelistVersionHistory: build.query<
      ListPricelistVersionHistoryApiResponse,
      ListPricelistVersionHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/pricelist-version-history`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    cancelPricelistVersion: build.mutation<
      CancelPricelistVersionApiResponse,
      CancelPricelistVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/pricelist-version/${queryArg.pricelistVersionId}`,
        method: 'DELETE',
        body: queryArg.versionedWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archiveTrim: build.mutation<ArchiveTrimApiResponse, ArchiveTrimApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/trim/${queryArg.trimId}`,
        method: 'DELETE',
        body: queryArg.pricedItemArchiveRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getTrim: build.query<GetTrimApiResponse, GetTrimApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/trim/${queryArg.trimId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateTrim: build.mutation<UpdateTrimApiResponse, UpdateTrimApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/trim/${queryArg.trimId}`,
        method: 'PATCH',
        body: queryArg.trimWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createTrim: build.mutation<CreateTrimApiResponse, CreateTrimApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/trim`,
        method: 'POST',
        body: queryArg.trimWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listTrim: build.query<ListTrimApiResponse, ListTrimApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/trim`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listTrimFeatureAssignments: build.query<
      ListTrimFeatureAssignmentsApiResponse,
      ListTrimFeatureAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/trim/${queryArg.trimId}/feature-assignment`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    putTrimFeatureAssignments: build.mutation<
      PutTrimFeatureAssignmentsApiResponse,
      PutTrimFeatureAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/trim/${queryArg.trimId}/feature-assignment`,
        method: 'PUT',
        body: queryArg.replaceTrimFeatureAssignmentsRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    putTrimUpholstery: build.mutation<PutTrimUpholsteryApiResponse, PutTrimUpholsteryApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/trim/${queryArg.trimId}/upholstery`,
        method: 'PUT',
        body: queryArg.replaceTrimUpholsteryRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archiveUpholstery: build.mutation<ArchiveUpholsteryApiResponse, ArchiveUpholsteryApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/upholstery/${queryArg.upholsteryId}`,
        method: 'DELETE',
        body: queryArg.pricedItemArchiveRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getUpholstery: build.query<GetUpholsteryApiResponse, GetUpholsteryApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/upholstery/${queryArg.upholsteryId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateUpholstery: build.mutation<UpdateUpholsteryApiResponse, UpdateUpholsteryApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/upholstery/${queryArg.upholsteryId}`,
        method: 'PATCH',
        body: queryArg.upholsteryWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createUpholstery: build.mutation<CreateUpholsteryApiResponse, CreateUpholsteryApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/upholstery`,
        method: 'POST',
        body: queryArg.upholsteryWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listUpholstery: build.query<ListUpholsteryApiResponse, ListUpholsteryApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/upholstery`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    archiveVariant: build.mutation<ArchiveVariantApiResponse, ArchiveVariantApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/variant/${queryArg.variantId}`,
        method: 'DELETE',
        body: queryArg.pricedItemArchiveRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getVariant: build.query<GetVariantApiResponse, GetVariantApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/variant/${queryArg.variantId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateVariant: build.mutation<UpdateVariantApiResponse, UpdateVariantApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/variant/${queryArg.variantId}`,
        method: 'PATCH',
        body: queryArg.variantItemWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createVariant: build.mutation<CreateVariantApiResponse, CreateVariantApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/variant`,
        method: 'POST',
        body: queryArg.variantItemWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listVariant: build.query<ListVariantApiResponse, ListVariantApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/variant`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    bulkUpdateVariantMatrix: build.mutation<
      BulkUpdateVariantMatrixApiResponse,
      BulkUpdateVariantMatrixApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/variant-matrix/bulk-update`,
        method: 'POST',
        body: queryArg.bulkVariantUpdateRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getVariantMatrix: build.query<GetVariantMatrixApiResponse, GetVariantMatrixApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/variant-matrix`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    putVariantMatrix: build.mutation<PutVariantMatrixApiResponse, PutVariantMatrixApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/variant-matrix`,
        method: 'PUT',
        body: queryArg.variantMatrixWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    patchVariantMatrixCell: build.mutation<
      PatchVariantMatrixCellApiResponse,
      PatchVariantMatrixCellApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/catalogue/model-year/${queryArg.modelYearId}/variant-matrix/${queryArg.variantId}`,
        method: 'PATCH',
        body: queryArg.variantItemWriteRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    copyConfiguration: build.mutation<CopyConfigurationApiResponse, CopyConfigurationApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}/copy`,
        method: 'POST',
        body: queryArg.copyConfigurationRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    createConfiguration: build.mutation<CreateConfigurationApiResponse, CreateConfigurationApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration`,
        method: 'POST',
        body: queryArg.createConfigurationRequestBody,
        headers: {
          'X-Branch': queryArg['X-Branch'],
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    deleteConfiguration: build.mutation<DeleteConfigurationApiResponse, DeleteConfigurationApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}`,
        method: 'DELETE',
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getConfigurationDetail: build.query<
      GetConfigurationDetailApiResponse,
      GetConfigurationDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateConfiguration: build.mutation<UpdateConfigurationApiResponse, UpdateConfigurationApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}`,
        method: 'PUT',
        body: queryArg.updateConfigurationRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    evaluateConfiguration: build.query<
      EvaluateConfigurationApiResponse,
      EvaluateConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/evaluate`,
        method: 'POST',
        body: queryArg.evaluateConfigurationRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    exportConfigurationOfferSheet: build.mutation<
      ExportConfigurationOfferSheetApiResponse,
      ExportConfigurationOfferSheetApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}/offer-sheet`,
        method: 'POST',
        body: queryArg.exportConfigurationOfferSheetRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getConfigurationByVehicle: build.query<
      GetConfigurationByVehicleApiResponse,
      GetConfigurationByVehicleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/vehicle/${queryArg.vehicleId}/configuration`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getConfigurationCustomerView: build.query<
      GetConfigurationCustomerViewApiResponse,
      GetConfigurationCustomerViewApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}/customer-view`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listBusinessCaseConfigurations: build.query<
      ListBusinessCaseConfigurationsApiResponse,
      ListBusinessCaseConfigurationsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/business-case/${queryArg.businessCaseId}/configuration`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    listInterestConfigurations: build.query<
      ListInterestConfigurationsApiResponse,
      ListInterestConfigurationsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/interest/${queryArg.interestId}/configuration`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    repriceConfiguration: build.mutation<
      RepriceConfigurationApiResponse,
      RepriceConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}/reprice`,
        method: 'POST',
        body: queryArg.repriceConfigurationRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    applyImporterStatus: build.mutation<ApplyImporterStatusApiResponse, ApplyImporterStatusApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/order/${queryArg.orderId}/importer-status`,
        method: 'POST',
        body: queryArg.importerStatusRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
          Authorization: queryArg.authorization,
        },
      }),
    }),
    cancelOrder: build.mutation<CancelOrderApiResponse, CancelOrderApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/order/${queryArg.orderId}/cancel`,
        method: 'POST',
        body: queryArg.cancelOrderRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    changeFactoryReference: build.mutation<
      ChangeFactoryReferenceApiResponse,
      ChangeFactoryReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/order/${queryArg.orderId}/factory-reference`,
        method: 'PUT',
        body: queryArg.changeFactoryReferenceRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    commitConfigurationToBusinessCase: build.mutation<
      CommitConfigurationToBusinessCaseApiResponse,
      CommitConfigurationToBusinessCaseApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}/commit-to-business-case`,
        method: 'POST',
        body: queryArg.commitConfigurationToBusinessCaseRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getVehicleOrder: build.query<GetVehicleOrderApiResponse, GetVehicleOrderApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/order/${queryArg.orderId}`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getVehicleOrderFactoryRecord: build.query<
      GetVehicleOrderFactoryRecordApiResponse,
      GetVehicleOrderFactoryRecordApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/order/${queryArg.orderId}/factory-record`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    handoverOrder: build.mutation<HandoverOrderApiResponse, HandoverOrderApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/order/${queryArg.orderId}/handover`,
        method: 'POST',
        body: queryArg.handoverRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    orderConfiguration: build.mutation<OrderConfigurationApiResponse, OrderConfigurationApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}/order`,
        method: 'POST',
        body: queryArg.orderConfigurationRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    recordOrderArrival: build.mutation<RecordOrderArrivalApiResponse, RecordOrderArrivalApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/order/${queryArg.orderId}/arrival`,
        method: 'POST',
        body: queryArg.arrivalRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    registerExternalOrder: build.mutation<
      RegisterExternalOrderApiResponse,
      RegisterExternalOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/configuration/${queryArg.configurationId}/register-external`,
        method: 'POST',
        body: queryArg.registerExternalOrderRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    updateOrderStatus: build.mutation<UpdateOrderStatusApiResponse, UpdateOrderStatusApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/new-vehicle/order/${queryArg.orderId}/status`,
        method: 'POST',
        body: queryArg.updateOrderStatusRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export {injectedRtkApi as newVehicleGeneratedApi};
export type ArchiveColourApiResponse = unknown;
export type ArchiveColourApiArg = {
  colourId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  pricedItemArchiveRequestBody: PricedItemArchiveRequestBody;
};
export type GetColourApiResponse = /** status 200  */ ColourResponseBody;
export type GetColourApiArg = {
  colourId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateColourApiResponse = /** status 200  */ ColourResponseBody;
export type UpdateColourApiArg = {
  colourId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  colourWriteRequestBody: ColourWriteRequestBody;
};
export type CreateColourApiResponse = /** status 201  */ ColourResponseBody;
export type CreateColourApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  colourWriteRequestBody: ColourWriteRequestBody;
};
export type ListColourApiResponse = /** status 200  */ ColourListResponseBody;
export type ListColourApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type PutColourTrimsApiResponse = /** status 200  */ OfferedTrimResponseBody[];
export type PutColourTrimsApiArg = {
  colourId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  replaceColourTrimsRequestBody: ReplaceColourTrimsRequestBody;
};
export type GetColourUpholsteryRestrictionsApiResponse =
  /** status 200  */ ColourUpholsteryRestrictionsResponseBody;
export type GetColourUpholsteryRestrictionsApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type PutColourUpholsteryRestrictionsApiResponse =
  /** status 200  */ ColourUpholsteryRestrictionsResponseBody;
export type PutColourUpholsteryRestrictionsApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  replaceColourUpholsteryRestrictionsRequestBody: ReplaceColourUpholsteryRestrictionsRequestBody;
};
export type ArchiveEngineApiResponse = unknown;
export type ArchiveEngineApiArg = {
  engineId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type GetEngineApiResponse = /** status 200  */ EngineResponseBody;
export type GetEngineApiArg = {
  engineId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateEngineApiResponse = /** status 200  */ EngineResponseBody;
export type UpdateEngineApiArg = {
  engineId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  engineWriteRequestBody: EngineWriteRequestBody;
};
export type CreateEngineApiResponse = /** status 201  */ EngineResponseBody;
export type CreateEngineApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  engineWriteRequestBody: EngineWriteRequestBody;
};
export type ListEngineApiResponse = /** status 200  */ EngineListResponseBody;
export type ListEngineApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type EvaluateAuthorConfigurationApiResponse =
  /** status 200  */ EvaluateConfigurationResponseBody;
export type EvaluateAuthorConfigurationApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  evaluateAuthorConfigurationRequestBody: EvaluateAuthorConfigurationRequestBody;
};
export type ArchiveFeatureApiResponse = unknown;
export type ArchiveFeatureApiArg = {
  featureId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type GetFeatureApiResponse = /** status 200  */ FeatureResponseBody;
export type GetFeatureApiArg = {
  featureId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateFeatureApiResponse = /** status 200  */ FeatureResponseBody;
export type UpdateFeatureApiArg = {
  featureId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  featureWriteRequestBody: FeatureWriteRequestBody;
};
export type CreateFeatureApiResponse = /** status 201  */ FeatureResponseBody;
export type CreateFeatureApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  featureWriteRequestBody: FeatureWriteRequestBody;
};
export type ListFeatureApiResponse = /** status 200  */ FeatureListResponseBody;
export type ListFeatureApiArg = {
  /** Only features the model year uses: assigned to a non-archived trim of the year or a member of a non-archived package of the year. An unknown model year gives an empty list. */
  modelYearId?: string;
  /** Case-insensitive substring of the name, the factory code or any code. Blank lists every feature. */
  search?: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type CreateFeatureRuleApiResponse = /** status 201  */ FeatureRuleResponseBody;
export type CreateFeatureRuleApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  featureRuleWriteRequestBody: FeatureRuleWriteRequestBody;
};
export type ListFeatureRuleApiResponse = /** status 200  */ FeatureRuleListResponseBody;
export type ListFeatureRuleApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type DeleteFeatureRuleApiResponse = unknown;
export type DeleteFeatureRuleApiArg = {
  featureRuleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type GetFeatureRuleApiResponse = /** status 200  */ FeatureRuleResponseBody;
export type GetFeatureRuleApiArg = {
  featureRuleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateFeatureRuleApiResponse = /** status 200  */ FeatureRuleResponseBody;
export type UpdateFeatureRuleApiArg = {
  featureRuleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  featureRuleWriteRequestBody: FeatureRuleWriteRequestBody;
};
export type GetAuthorConfiguratorBundleApiResponse =
  /** status 200  */ AuthorConfiguratorBundleResponseBody;
export type GetAuthorConfiguratorBundleApiArg = {
  modelYearId: string;
  previewAsConfigurator?: boolean;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type GetCatalogueTreeApiResponse = /** status 200  */ CatalogueTreeResponseBody;
export type GetCatalogueTreeApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type GetConfiguratorBundleApiResponse = /** status 200  */ ConfiguratorBundleResponseBody;
export type GetConfiguratorBundleApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ArchiveMakeApiResponse = unknown;
export type ArchiveMakeApiArg = {
  makeId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type GetMakeApiResponse = /** status 200  */ MakeResponseBody;
export type GetMakeApiArg = {
  makeId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateMakeApiResponse = /** status 200  */ MakeResponseBody;
export type UpdateMakeApiArg = {
  makeId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  makeWriteRequestBody: MakeWriteRequestBody;
};
export type CreateMakeApiResponse = /** status 201  */ MakeResponseBody;
export type CreateMakeApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  makeWriteRequestBody: MakeWriteRequestBody;
};
export type ListMakeApiResponse = /** status 200  */ MakeListResponseBody;
export type ListMakeApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type GetMakeOrderStatusMappingApiResponse =
  /** status 200  */ MakeOrderStatusMappingResponseBody;
export type GetMakeOrderStatusMappingApiArg = {
  makeId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type GetMakeOrderStatusSignalMappingApiResponse =
  /** status 200  */ MakeOrderStatusSignalMappingResponseBody;
export type GetMakeOrderStatusSignalMappingApiArg = {
  makeId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ListUnmappedMakeStatusApiResponse = /** status 200  */ UnmappedMakeStatusResponseBody[];
export type ListUnmappedMakeStatusApiArg = {
  makeId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ArchiveModelApiResponse = unknown;
export type ArchiveModelApiArg = {
  modelId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type GetModelApiResponse = /** status 200  */ ModelResponseBody;
export type GetModelApiArg = {
  modelId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateModelApiResponse = /** status 200  */ ModelResponseBody;
export type UpdateModelApiArg = {
  modelId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  modelWriteRequestBody: ModelWriteRequestBody;
};
export type CreateModelApiResponse = /** status 201  */ ModelResponseBody;
export type CreateModelApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  modelWriteRequestBody: ModelWriteRequestBody;
};
export type ListModelApiResponse = /** status 200  */ ModelListResponseBody;
export type ListModelApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UploadModelImageApiResponse = /** status 201  */ ImageAssetRefResponseBody;
export type UploadModelImageApiArg = {
  modelId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ArchiveModelYearApiResponse = unknown;
export type ArchiveModelYearApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type GetModelYearApiResponse = /** status 200  */ ModelYearResponseBody;
export type GetModelYearApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateModelYearApiResponse = /** status 200  */ ModelYearResponseBody;
export type UpdateModelYearApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  modelYearWriteRequestBody: ModelYearWriteRequestBody;
};
export type CreateModelYearApiResponse = /** status 201  */ ModelYearResponseBody;
export type CreateModelYearApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  modelYearWriteRequestBody: ModelYearWriteRequestBody;
};
export type ListModelYearApiResponse = /** status 200  */ ModelYearListResponseBody;
export type ListModelYearApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type DuplicateModelYearApiResponse = /** status 201  */ ModelYearResponseBody;
export type DuplicateModelYearApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  duplicateModelYearRequestBody: DuplicateModelYearRequestBody;
};
export type GetModelYearReadinessApiResponse = /** status 200  */ ModelYearReadinessResponseBody;
export type GetModelYearReadinessApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type PublishModelYearApiResponse = /** status 200  */ PublishReadinessResponseBody;
export type PublishModelYearApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type UnpublishModelYearApiResponse = unknown;
export type UnpublishModelYearApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type ArchivePackageApiResponse = unknown;
export type ArchivePackageApiArg = {
  packageId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  pricedItemArchiveRequestBody: PricedItemArchiveRequestBody;
};
export type GetPackageApiResponse = /** status 200  */ PackageResponseBody;
export type GetPackageApiArg = {
  packageId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdatePackageApiResponse = /** status 200  */ PackageResponseBody;
export type UpdatePackageApiArg = {
  packageId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  packageWriteRequestBody: PackageWriteRequestBody;
};
export type CreatePackageApiResponse = /** status 201  */ PackageResponseBody;
export type CreatePackageApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  packageWriteRequestBody: PackageWriteRequestBody;
};
export type ListPackageApiResponse = /** status 200  */ PackageListResponseBody;
export type ListPackageApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ApplyMidYearPriceAdjustmentApiResponse = /** status 200  */ PriceAdjustmentResponseBody;
export type ApplyMidYearPriceAdjustmentApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  priceAdjustmentRequestBody: PriceAdjustmentRequestBody;
};
export type ApplyPricedItemChangeBatchApiResponse =
  /** status 200  */ PricedItemChangeBatchResponseBody;
export type ApplyPricedItemChangeBatchApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  pricedItemChangeBatchRequestBody: PricedItemChangeBatchRequestBody;
};
export type ListPricelistVersionHistoryApiResponse =
  /** status 200  */ PricelistVersionHistoryResponseBody;
export type ListPricelistVersionHistoryApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type CancelPricelistVersionApiResponse = unknown;
export type CancelPricelistVersionApiArg = {
  modelYearId: string;
  pricelistVersionId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  versionedWriteRequestBody: VersionedWriteRequestBody;
};
export type ArchiveTrimApiResponse = unknown;
export type ArchiveTrimApiArg = {
  trimId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  pricedItemArchiveRequestBody: PricedItemArchiveRequestBody;
};
export type GetTrimApiResponse = /** status 200  */ TrimResponseBody;
export type GetTrimApiArg = {
  trimId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateTrimApiResponse = /** status 200  */ TrimResponseBody;
export type UpdateTrimApiArg = {
  trimId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  trimWriteRequestBody: TrimWriteRequestBody;
};
export type CreateTrimApiResponse = /** status 201  */ TrimResponseBody;
export type CreateTrimApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  trimWriteRequestBody: TrimWriteRequestBody;
};
export type ListTrimApiResponse = /** status 200  */ TrimListResponseBody;
export type ListTrimApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ListTrimFeatureAssignmentsApiResponse =
  /** status 200  */ TrimFeatureAssignmentResponseBody[];
export type ListTrimFeatureAssignmentsApiArg = {
  trimId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type PutTrimFeatureAssignmentsApiResponse =
  /** status 200  */ TrimFeatureAssignmentResponseBody[];
export type PutTrimFeatureAssignmentsApiArg = {
  trimId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  replaceTrimFeatureAssignmentsRequestBody: ReplaceTrimFeatureAssignmentsRequestBody;
};
export type PutTrimUpholsteryApiResponse = /** status 200  */ object;
export type PutTrimUpholsteryApiArg = {
  trimId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  replaceTrimUpholsteryRequestBody: ReplaceTrimUpholsteryRequestBody;
};
export type ArchiveUpholsteryApiResponse = unknown;
export type ArchiveUpholsteryApiArg = {
  upholsteryId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  pricedItemArchiveRequestBody: PricedItemArchiveRequestBody;
};
export type GetUpholsteryApiResponse = /** status 200  */ UpholsteryResponseBody;
export type GetUpholsteryApiArg = {
  upholsteryId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateUpholsteryApiResponse = /** status 200  */ UpholsteryResponseBody;
export type UpdateUpholsteryApiArg = {
  upholsteryId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  upholsteryWriteRequestBody: UpholsteryWriteRequestBody;
};
export type CreateUpholsteryApiResponse = /** status 201  */ UpholsteryResponseBody;
export type CreateUpholsteryApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  upholsteryWriteRequestBody: UpholsteryWriteRequestBody;
};
export type ListUpholsteryApiResponse = /** status 200  */ UpholsteryListResponseBody;
export type ListUpholsteryApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ArchiveVariantApiResponse = unknown;
export type ArchiveVariantApiArg = {
  variantId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  pricedItemArchiveRequestBody: PricedItemArchiveRequestBody;
};
export type GetVariantApiResponse = /** status 200  */ VariantResponseBody;
export type GetVariantApiArg = {
  variantId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateVariantApiResponse = /** status 200  */ VariantResponseBody;
export type UpdateVariantApiArg = {
  variantId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  variantItemWriteRequestBody: VariantItemWriteRequestBody;
};
export type CreateVariantApiResponse = /** status 201  */ VariantResponseBody;
export type CreateVariantApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  variantItemWriteRequestBody: VariantItemWriteRequestBody;
};
export type ListVariantApiResponse = /** status 200  */ VariantListResponseBody;
export type ListVariantApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type BulkUpdateVariantMatrixApiResponse = /** status 200  */ VariantMatrixResponseBody;
export type BulkUpdateVariantMatrixApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  bulkVariantUpdateRequestBody: BulkVariantUpdateRequestBody;
};
export type GetVariantMatrixApiResponse = /** status 200  */ VariantMatrixResponseBody;
export type GetVariantMatrixApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type PutVariantMatrixApiResponse = /** status 200  */ VariantMatrixResponseBody;
export type PutVariantMatrixApiArg = {
  modelYearId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  variantMatrixWriteRequestBody: VariantMatrixWriteRequestBody;
};
export type PatchVariantMatrixCellApiResponse = /** status 200  */ VariantResponseBody;
export type PatchVariantMatrixCellApiArg = {
  modelYearId: string;
  variantId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  variantItemWriteRequestBody: VariantItemWriteRequestBody;
};
export type CopyConfigurationApiResponse = /** status 201  */ UuidResponseBody;
export type CopyConfigurationApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  copyConfigurationRequestBody: CopyConfigurationRequestBody;
};
export type CreateConfigurationApiResponse = /** status 201  */ UuidResponseBody;
export type CreateConfigurationApiArg = {
  'X-Branch': string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  createConfigurationRequestBody: CreateConfigurationRequestBody;
};
export type DeleteConfigurationApiResponse = unknown;
export type DeleteConfigurationApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type GetConfigurationDetailApiResponse = /** status 200  */ ConfigurationDetailResponseBody;
export type GetConfigurationDetailApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type UpdateConfigurationApiResponse = unknown;
export type UpdateConfigurationApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  updateConfigurationRequestBody: UpdateConfigurationRequestBody;
};
export type EvaluateConfigurationApiResponse = /** status 200  */ EvaluateConfigurationResponseBody;
export type EvaluateConfigurationApiArg = {
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  evaluateConfigurationRequestBody: EvaluateConfigurationRequestBody;
};
export type ExportConfigurationOfferSheetApiResponse = unknown;
export type ExportConfigurationOfferSheetApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  exportConfigurationOfferSheetRequestBody: ExportConfigurationOfferSheetRequestBody;
};
export type GetConfigurationByVehicleApiResponse =
  /** status 200  */ ConfigurationDetailResponseBody;
export type GetConfigurationByVehicleApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type GetConfigurationCustomerViewApiResponse =
  /** status 200  */ ConfigurationCustomerViewResponseBody;
export type GetConfigurationCustomerViewApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ListBusinessCaseConfigurationsApiResponse =
  /** status 200  */ InterestConfigurationListItemResponseBody[];
export type ListBusinessCaseConfigurationsApiArg = {
  businessCaseId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type ListInterestConfigurationsApiResponse =
  /** status 200  */ InterestConfigurationListItemResponseBody[];
export type ListInterestConfigurationsApiArg = {
  interestId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type RepriceConfigurationApiResponse = /** status 200  */ PriceSnapshotResponseBody;
export type RepriceConfigurationApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  repriceConfigurationRequestBody: RepriceConfigurationRequestBody;
};
export type ApplyImporterStatusApiResponse = /** status 200  */ VehicleOrderDetailResponseBody;
export type ApplyImporterStatusApiArg = {
  orderId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  /** Service JWT tokens are allowed (allowed services are esb) */
  authorization?: string;
  importerStatusRequestBody: ImporterStatusRequestBody;
};
export type CancelOrderApiResponse = /** status 200  */ VehicleOrderDetailResponseBody;
export type CancelOrderApiArg = {
  orderId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  cancelOrderRequestBody: CancelOrderRequestBody;
};
export type ChangeFactoryReferenceApiResponse =
  /** status 200  */ VehicleOrderDetailResponseBody;
export type ChangeFactoryReferenceApiArg = {
  orderId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  changeFactoryReferenceRequestBody: ChangeFactoryReferenceRequestBody;
};
export type CommitConfigurationToBusinessCaseApiResponse =
  /** status 201  */ CommitConfigurationResponseBody;
export type CommitConfigurationToBusinessCaseApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  commitConfigurationToBusinessCaseRequestBody: CommitConfigurationToBusinessCaseRequestBody;
};
export type GetVehicleOrderApiResponse = /** status 200  */ VehicleOrderDetailResponseBody;
export type GetVehicleOrderApiArg = {
  orderId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type GetVehicleOrderFactoryRecordApiResponse =
  /** status 200  */ VehicleOrderFactoryRecordResponseBody;
export type GetVehicleOrderFactoryRecordApiArg = {
  orderId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type HandoverOrderApiResponse = /** status 200  */ VehicleOrderDetailResponseBody;
export type HandoverOrderApiArg = {
  orderId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  handoverRequestBody: HandoverRequestBody;
};
export type OrderConfigurationApiResponse = /** status 201  */ MaterializationResponseBody;
export type OrderConfigurationApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  orderConfigurationRequestBody: OrderConfigurationRequestBody;
};
export type RecordOrderArrivalApiResponse = /** status 200  */ VehicleOrderDetailResponseBody;
export type RecordOrderArrivalApiArg = {
  orderId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  arrivalRequestBody: ArrivalRequestBody;
};
export type RegisterExternalOrderApiResponse = /** status 201  */ MaterializationResponseBody;
export type RegisterExternalOrderApiArg = {
  configurationId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  registerExternalOrderRequestBody: RegisterExternalOrderRequestBody;
};
export type UpdateOrderStatusApiResponse = /** status 200  */ VehicleOrderDetailResponseBody;
export type UpdateOrderStatusApiArg = {
  orderId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  updateOrderStatusRequestBody: UpdateOrderStatusRequestBody;
};
export type Error = {
  errors?: {
    message?: string;
    code?: string;
    /** Only on an error of POST /model-year/{modelYearId}/priced-item-change-batch that one operation caused: the index of that operation in `operations`. Absent on an error of the whole batch, for example one from the commit. */
    operationIndex?: number;
    /** The reason of a `DMS-NV-CT-0078` refusal, for example `duplicateTarget` or `trimSwitchWithNewItemRow`. Absent for other codes. */
    reason?: string;
    /** The trim that a `trimSwitchWithNewItemRow` refusal names: a publication status switch of this trim and a new colour or package offered on it cannot be in one batch. Absent for other reasons. */
    trimId?: string;
  }[];
  validationErrors?: {
    message?: string;
    field?: string;
  }[];
};
/** A placement refused because another active order of the same make holds the factory reference. */
export type FactoryReferenceInUseResponseBody = {
  errors: {
    message: string;
    code: 'DMS-NV-VO-0015';
  }[];
  /** The active vehicle order that holds the factory reference. */
  vehicleOrderId: string;
  /** The vehicle of the active order that holds the factory reference. */
  vehicleId: string;
};
export type VersionedWriteRequestBody = {
  /** Optimistic aggregate version. Reload after a 409 stale-version response. */
  version: number;
};
/** The new price list version a create or remove of a priced item on a published model year creates (D88). Applies at once. Ignored on a draft model year. */
export type PricelistVersionRequestBody = {
  /** The new pricelistVersionLabel of the model year (1–255 characters, not blank). Must differ from the current label and from every label the model year has used (400 DMS-NV-CT-0032). */
  label: string;
  note?: string | null;
};
export type PricedItemArchiveRequestBody = {
  /** Optimistic aggregate version. Reload after a 409 stale-version response. */
  version: number;
  /** Required to archive an item of the price list on a published model year (else 409 DMS-NV-CT-0054); a colour or package is in it through its rows on online trims, each listed as removed (D102). Ignored for a draft trim, a draft package, a colour or package without a row on an online trim, a disabled Variant, a Variant of a draft trim, and on a draft model year. */
  pricelistVersion?: PricelistVersionRequestBody | null;
};
export type MoneyDecimal = string;
export type NullableMoneyDecimal = string | null;
export type ColourResponseBody = {
  id: string;
  version: number;
  archived: boolean;
  modelYearId: string;
  name: string;
  codes: string[];
  /** Trims on which the colour is offered, each with its price there; a colour with no trim is unavailable everywhere (fail-closed). */
  trims: OfferedTrimResponseBody[];
  kind?: string | null;
  hex?: string | null;
  factoryCode?: string | null;
};
export type OfferedTrimResponseBody = {
  trimId: string;
  /** Net price of the item on this trim; 0 means included. */
  priceNet: MoneyDecimal;
  costNet?: NullableMoneyDecimal;
  /** Id of priceNet for a mid-year price adjustment with scope colourTrim or packageTrim. Derived from the trim and the item; ignored when sent back. */
  priceTargetId: string;
};
export type MoneyInput = string;
export type NullableMoneyInput = string | null;
export type ColourWriteRequestBody = {
  modelYearId: string;
  name: string;
  codes: string[];
  /** Vehicle-catalogue `color_type` key for a passenger car, e.g. `COLORSPECIFICATION_METALLIC`. Validated against the vehicle catalogue (unknown key 400, catalogue unavailable 503 DMS-NV-CT-0042). Null means a solid colour without a specification. */
  kind?: string | null;
  hex?: string | null;
  factoryCode?: string | null;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
};
export type ColourListResponseBody = {
  items: ColourResponseBody[];
  total: number;
};
export type OfferedTrimRequestBody = {
  trimId: string;
  /** Net price of the item on this trim; 0 means included. On a published model year a kept trim's price that differs from the stored one (compared numerically) is refused with 409 DMS-NV-CT-0054; change it through the mid-year price adjustment (`colourTrim`, `packageTrim`). */
  priceNet: MoneyInput;
  /** Omitted keeps the stored cost, none for a new trim. Ignored without cost access. */
  costNet?: NullableMoneyInput;
};
export type ReplaceColourTrimsRequestBody = {
  /** The complete set of trims the colour is offered on, each with its price there. An empty set makes the colour unavailable on every trim. */
  trims: OfferedTrimRequestBody[];
  version: number;
  /** Required on a published model year when the request adds or omits a row on an online trim (else 409 DMS-NV-CT-0054); the version lists each such row as created or removed. A kept row on an online trim keeps its price also with it (409 DMS-NV-CT-0054). Sent with no such row added or omitted while the colour has rows on online trims: 400 DMS-NV-CT-0065. Ignored when every row is on a draft or archived trim, and on a draft model year. 409 DMS-NV-CT-0066 while a version is scheduled; 400 DMS-NV-CT-0032 for a used label. */
  pricelistVersion?: PricelistVersionRequestBody | null;
};
export type ColourUpholsteryRestrictionResponseBody = {
  colourId: string;
  upholsteryId: string;
};
export type ColourUpholsteryRestrictionsResponseBody = {
  modelYearId: string;
  version: number;
  restrictions: ColourUpholsteryRestrictionResponseBody[];
};
export type ColourUpholsteryRestrictionRequestBody = {
  colourId: string;
  upholsteryId: string;
};
export type ReplaceColourUpholsteryRestrictionsRequestBody = {
  restrictions: ColourUpholsteryRestrictionRequestBody[];
  version: number;
};
export type EngineResponseBody = {
  id: string;
  version: number;
  archived: boolean;
  modelYearId: string;
  name: string;
  codes: string[];
  powerKw: string;
  powerPs?: string | null;
  displacementCcm?: number | null;
  factoryCode?: string | null;
  transmissionCode?: string | null;
  /** Vehicle-catalogue `fuel_type` key for a passenger car, e.g. `FUELTYPE_PETROL`. */
  fuel: string;
  /** Vehicle-catalogue `hybrid_type` key for a passenger car, e.g. `HYBRIDTYPE_PHEV`. */
  hybridType?: string | null;
  /** Vehicle-catalogue `transmission` key for a passenger car, e.g. `TRANSMISSION_AUTOMATIC`. */
  transmission: string;
  /** Vehicle-catalogue `drive` key for a passenger car, e.g. `DRIVE_FRONT`. */
  drive: string;
  technicalData?: EngineTechnicalData;
};
export type EngineWriteRequestBody = {
  modelYearId: string;
  name: string;
  codes: string[];
  powerKw: string;
  powerPs?: string | null;
  displacementCcm?: number | null;
  factoryCode?: string | null;
  transmissionCode?: string | null;
  /** Vehicle-catalogue `fuel_type` key for a passenger car, e.g. `FUELTYPE_PETROL`. Validated against the vehicle catalogue (unknown key 400, catalogue unavailable 503 DMS-NV-CT-0042). A plug-in hybrid is `FUELTYPE_HYBRID` with hybridType `HYBRIDTYPE_PHEV`. */
  fuel: string;
  /** Vehicle-catalogue `hybrid_type` key for a passenger car, e.g. `HYBRIDTYPE_PHEV`. Validated against the vehicle catalogue (unknown key 400, catalogue unavailable 503 DMS-NV-CT-0042). Only allowed when fuel is `FUELTYPE_HYBRID` (DMS-NV-CT-0052); optional for a hybrid. PATCH: omitted keeps the stored value. */
  hybridType?: string | null;
  /** Vehicle-catalogue `transmission` key for a passenger car, e.g. `TRANSMISSION_AUTOMATIC`. Validated against the vehicle catalogue (unknown key 400, catalogue unavailable 503 DMS-NV-CT-0042). */
  transmission: string;
  /** Vehicle-catalogue `drive` key for a passenger car, e.g. `DRIVE_FRONT`. Validated against the vehicle catalogue (unknown key 400, catalogue unavailable 503 DMS-NV-CT-0042). */
  drive: string;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
  /** POST: omitted or null stores none. PATCH: present replaces the whole object (null or {} clears), omitted keeps the stored value. */
  technicalData?: EngineTechnicalData | null;
};
/** Engine battery, charging and particulate filter under their vehicle data keys. Only set keys are present; keys that do not fit the engine's fuel are refused (400 DMS-NV-CT-0075). */
export type EngineTechnicalData = {
  /** Usable battery capacity in kWh (the vehicle data's legacy name ends in Wh). Decimal string, e.g. `46.8`. */
  batteryCapacityWh?: Decimal | null;
  batteryCapacityAh?: Decimal | null;
  /** V */
  batteryVoltage?: Decimal | null;
  /** Vehicle-catalogue `battery_type` key, e.g. `BATTERYTYPE_LI_ION`. */
  batteryType?: string | null;
  /** kW */
  chargingAC?: Decimal | null;
  /** kW */
  chargingDC?: Decimal | null;
  /** Hours */
  chargingTimeAC?: Decimal | null;
  /** Minutes */
  chargingTimeDC?: number | null;
  /** Vehicle-catalogue `charging_connector_type` key, e.g. `CHARGINGCONNECTORTYPE_CCS2`. */
  chargingConnectorType?: string | null;
  hasDpf?: boolean | null;
};
/** Variant WLTP range, consumption, emissions and body dimensions under their vehicle data keys. Only set keys are present; keys that do not fit the engine's fuel are refused (400 DMS-NV-CT-0075). */
export type VariantTechnicalData = {
  /** km */
  electricRange?: number | null;
  electricRangeCity?: number | null;
  combinedRange?: number | null;
  combinedRangeCity?: number | null;
  /** l/100 km */
  fuelConsumptionWltpCombined?: Decimal | null;
  fuelConsumptionWltpCityCenter?: Decimal | null;
  fuelConsumptionWltpOutskirts?: Decimal | null;
  fuelConsumptionWltpCountryRoads?: Decimal | null;
  fuelConsumptionWltpHighway?: Decimal | null;
  fuelConsumptionWltpWeighted?: Decimal | null;
  /** kWh/100 km */
  fuelConsumptionWltpCombinedKwh?: Decimal | null;
  fuelConsumptionWltpCityCenterKwh?: Decimal | null;
  fuelConsumptionWltpOutskirtsKwh?: Decimal | null;
  fuelConsumptionWltpCountryRoadsKwh?: Decimal | null;
  fuelConsumptionWltpHighwayKwh?: Decimal | null;
  fuelConsumptionWltpWeightedCombinedKwh?: Decimal | null;
  /** g/km */
  carbonDioxideEmission?: Decimal | null;
  carbonDioxideEmissionDischarged?: Decimal | null;
  carbonDioxideEmissionWeightedCombined?: Decimal | null;
  /** Vehicle-catalogue `emission_class` key, e.g. `EMISSIONCLASS_EURO_6`. */
  emissionClass?: string | null;
  /** mm, each a decimal string; omitted dimensions are unset. */
  dimensions?: {length?: Decimal; width?: Decimal; height?: Decimal} | null;
  /** mm */
  wheelBase?: number | null;
  /** kg */
  operatingWeight?: number | null;
  /** l */
  trunkSpace?: number | null;
};
export type EngineListResponseBody = {
  items: EngineResponseBody[];
  total: number;
};
export type EvaluationItemResponseBody = {
  id: string;
  type: 'trim' | 'variant' | 'colour' | 'upholstery' | 'feature' | 'package';
  availability: 'available' | 'unavailable';
  /** Returned for selected and auto-added items only. Active exclusions invalidate both selected endpoints regardless of request order. The human-readable reason is not a machine interface.
    unknown_item: the selected optional item identifier is unknown or unavailable to the evaluator.
    not_in_trim: a Feature assignment/applicability check or Package trim restriction failed.
    requires_unavailable: an active requirement could not be satisfied; it does not identify a removable counterpart.
    excluded: both selected endpoints of an active exclusion are invalidated.
    trim_not_orderable: the selected Trim is not currently orderable.
    variant_disabled: the selected Variant is disabled or does not belong to the selected Trim.
    not_available_with_colour: the selected Upholstery is unavailable with the selected Colour; an existing unavailable reason takes precedence.
    package_only: the selected Feature can be ordered only through a Package.
    not_available_for_trim: the selected Colour or Upholstery is unavailable for the selected Trim.
    wheel_set_conflict: more than one selected or auto-added Feature has kind wheel; a single wheel supplied by an applicable selected Package or by an active requires rule of an available Feature stays and the others are invalidated, two or more different supplied wheels are all invalidated, and without a supplied wheel a single non-standard wheel stays and the standard wheel is invalidated, otherwise every wheel is invalidated; an existing unavailable reason takes precedence.
    standard_inclusion: the selected Feature is applicable STANDARD equipment of the selected Trim, which includes it at zero; only a selected Package or an active requires rule may carry it into the selection. */
  reasonCode:
    | (
        | 'unknown_item'
        | 'not_in_trim'
        | 'requires_unavailable'
        | 'excluded'
        | 'trim_not_orderable'
        | 'variant_disabled'
        | 'not_available_with_colour'
        | 'package_only'
        | 'not_available_for_trim'
        | 'wheel_set_conflict'
        | 'standard_inclusion'
        | null
      )
    | null;
  reason: string | null;
  priceNet?: NullableMoneyDecimal | null;
  priceGross?: NullableMoneyDecimal | null;
  costNet?: NullableMoneyDecimal | null;
};
export type EvaluationTotalsResponseBody = {
  net: MoneyDecimal;
  vat: MoneyDecimal;
  gross: MoneyDecimal;
  costNet?: NullableMoneyDecimal | null;
  bundleSavingsNet: MoneyDecimal;
};
export type EvaluateConfigurationResponseBody = {
  catalogueRevision: string;
  currency: string;
  vatRate: MoneyDecimal;
  items: EvaluationItemResponseBody[];
  autoAddedSelectionIds: string[];
  invalidatedSelectionIds: string[];
  totals: EvaluationTotalsResponseBody;
  proposedSellingPriceNet: NullableMoneyDecimal | null;
  proposedSellingPriceGross: NullableMoneyDecimal | null;
  /** Every OPTIONAL Feature, Colour and Package offered on the selected Trim with its resolved price; empty when the Trim is unknown. */
  offers: EvaluationOfferResponseBody[];
};
/** Resolved net price of an OPTIONAL Feature, a Colour or a Package offered on the selected Trim. A Feature is priced on the selection plus that Feature after package and requires expansion. Offers are prices, not availability: rule exclusions do not remove an offer. */
export type EvaluationOfferResponseBody = {
  type: 'feature' | 'colour' | 'package';
  id: string;
  priceNet: MoneyDecimal;
  priceGross: MoneyDecimal;
};
export type ProposedDiscount = {
  kind: 'percent' | 'amount';
  value: string;
  basis: 'net' | 'gross';
};
export type EvaluateAuthorConfigurationRequestBody = {
  modelYearId: string;
  trimId: string;
  variantId: string;
  colourId?: string | null;
  upholsteryId?: string | null;
  /** Selection order is not significant. The evaluator normalizes feature IDs deterministically; when selected features exclude each other, every conflicting selected feature is invalidated regardless of input order. */
  featureIds: string[];
  packageIds: string[];
  proposedDiscount?: ProposedDiscount | null;
  version: number;
};
export type FeatureKind = 'option' | 'wheel' | 'accessory' | 'colour' | 'upholstery';
export type FeatureFitStage = 'factory' | 'dealer';
export type FeatureCategory =
  | 'interior'
  | 'infotainment_communication'
  | 'safety_assistance'
  | 'exterior'
  | 'wheels_tyres'
  | 'mechanical'
  | 'load_space'
  | 'other';
export type FeatureResponseBody = {
  id: string;
  version: number;
  archived: boolean;
  name: string;
  codes: string[];
  kind: FeatureKind;
  fitStage: FeatureFitStage;
  standaloneOrderable: boolean;
  category: FeatureCategory;
  factoryCode?: string | null;
};
export type FeatureWriteRequestBody = {
  name: string;
  codes: string[];
  kind: FeatureKind;
  fitStage: FeatureFitStage;
  standaloneOrderable: boolean;
  category: FeatureCategory;
  factoryCode?: string | null;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
};
export type FeatureListResponseBody = {
  items: FeatureResponseBody[];
  total: number;
};
export type SelectionConditionResponseBody = {
  anyOfVariantIds: string[];
  allOfFeatureIds: string[];
};
export type FeatureRuleResponseBody = {
  id: string;
  version: number;
  archived: boolean;
  modelYearId: string;
  type: 'requires' | 'excludes' | 'autoAdd';
  sourceFeatureId: string;
  targetFeatureIds: string[];
  ifSelectedFeatureIds: string[];
  note?: string | null;
  appliesIf: SelectionConditionResponseBody;
  /** Trims the rule applies on; empty means every trim. */
  trimIds: string[];
};
export type SelectionConditionRequestBody = {
  anyOfVariantIds: string[];
  allOfFeatureIds: string[];
};
export type FeatureRuleWriteRequestBody = {
  modelYearId: string;
  type: 'requires' | 'excludes' | 'autoAdd';
  sourceFeatureId: string;
  targetFeatureIds: string[];
  ifSelectedFeatureIds: string[];
  note?: string | null;
  appliesIf: SelectionConditionRequestBody;
  /** Trims the rule applies on; empty means every trim. Omitted on create means every trim; omitted on PATCH keeps the stored trims. */
  trimIds?: string[];
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
};
export type FeatureRuleListResponseBody = {
  items: FeatureRuleResponseBody[];
  total: number;
};
export type PublicationStatus = 'draft' | 'online' | 'archived';
/** Price companions are display-only backend derivations (D82/D86); the frontend never computes gross from net (D3). */
export type PriceBasis = 'gross' | 'net';
export type CommercialAvailability = 'orderable' | 'preview' | 'sold_out';
export type ConfiguratorTrimResponseBody = {
  id: string;
  name: string;
  bodyStyle: string;
  type: string | null;
  publicationStatus: PublicationStatus;
  commercialAvailability: CommercialAvailability;
  orderableFrom: string | null;
  orderableUntil: string | null;
  basePriceNet: MoneyDecimal;
  fromPriceGross: MoneyDecimal;
  basePriceGross: MoneyDecimal;
  fromPriceNet: MoneyDecimal;
  costNet?: NullableMoneyDecimal | null;
};
export type Decimal = string;
export type ConfiguratorEngineResponseBody = {
  id: string;
  name: string;
  powerKw: Decimal;
  /** Vehicle-catalogue `fuel_type` key for a passenger car, e.g. `FUELTYPE_PETROL`. */
  fuel: string;
  /** Vehicle-catalogue `hybrid_type` key for a passenger car, e.g. `HYBRIDTYPE_PHEV`. */
  hybridType: string | null;
  /** Vehicle-catalogue `transmission` key for a passenger car, e.g. `TRANSMISSION_AUTOMATIC`. */
  transmission: string;
  /** Vehicle-catalogue `drive` key for a passenger car, e.g. `DRIVE_FRONT`. */
  drive: string;
  technicalData?: EngineTechnicalData;
};
export type ConfiguratorVariantResponseBody = {
  id: string;
  trimId: string;
  engineId: string;
  priceNet: MoneyDecimal;
  priceGross: MoneyDecimal;
  costNet?: NullableMoneyDecimal | null;
  orderCode: string;
  enabled: boolean;
  roofHeight: string | null;
  loadLength: string | null;
  gvwKg: number | null;
  payloadKg: number | null;
  technicalData?: VariantTechnicalData;
};
export type ConfiguratorOfferedTrimResponseBody = {
  trimId: string;
  /** Stored net price of the item on this trim; 0 means included. */
  priceNet: MoneyDecimal;
  /** Display-only gross companion of priceNet, derived from it with the bundle VAT rate (D86). */
  priceGross: MoneyDecimal;
  costNet?: NullableMoneyDecimal | null;
};
export type ConfiguratorColourResponseBody = {
  id: string;
  name: string;
  codes: string[];
  /** The trims the colour is offered on, each with its price there. */
  trims: ConfiguratorOfferedTrimResponseBody[];
  /** `#RRGGBB`. A backend from before T20-141691 omits it. */
  hex?: string | null;
};
export type ConfiguratorUpholsteryResponseBody = {
  id: string;
  name: string;
  priceNet: MoneyDecimal;
  priceGross: MoneyDecimal;
  costNet?: NullableMoneyDecimal | null;
  codes: string[];
  availableForTrimIds: string[];
  /** `#RRGGBB`. A backend from before T20-141691 omits it. */
  interiorColorHex?: string | null;
};
export type TrimFeatureInclusion = 'STANDARD' | 'OPTIONAL';
export type TrimFeatureInclusionResponseBody = {
  trimId: string;
  inclusion: TrimFeatureInclusion;
  /** The trim assignment's condition. A backend from before T20-142113 omits it: unrestricted. */
  appliesIf?: SelectionConditionResponseBody;
  /** Stored net price of the item on this trim, before conditional prices and variant overrides; null on STANDARD (included). */
  priceNet: NullableMoneyDecimal | null;
  /** Display-only gross companion of priceNet, derived from it with the bundle VAT rate (D86); null on STANDARD. */
  priceGross: NullableMoneyDecimal | null;
  costNet?: NullableMoneyDecimal | null;
};
export type ConfiguratorFeatureResponseBody = {
  id: string;
  name: string;
  kind: FeatureKind;
  fitStage: FeatureFitStage;
  standaloneOrderable: boolean;
  category: FeatureCategory;
  codes: string[];
  trimInclusions: TrimFeatureInclusionResponseBody[];
};
export type ConfiguratorPackageResponseBody = {
  id: string;
  name: string;
  description: string;
  memberFeatureIds: string[];
  /** The trims the package is offered on, each with its price there; a package without trims is offered nowhere. */
  trims: ConfiguratorOfferedTrimResponseBody[];
  codes: string[];
};
export type ConfiguratorFeatureExclusionResponseBody = {
  id: string;
  sourceFeatureId: string;
  targetFeatureId: string;
  appliesIf: SelectionConditionResponseBody;
};
export type AuthorConfiguratorBundleResponseBody = {
  catalogueRevision: string;
  priceBasis: PriceBasis;
  currency: string;
  vatRate: MoneyDecimal;
  trims: ConfiguratorTrimResponseBody[];
  engines: ConfiguratorEngineResponseBody[];
  variants: ConfiguratorVariantResponseBody[];
  colours: ConfiguratorColourResponseBody[];
  upholsteries: ConfiguratorUpholsteryResponseBody[];
  features: ConfiguratorFeatureResponseBody[];
  packages: ConfiguratorPackageResponseBody[];
  colourUpholsteryRestrictions: ColourUpholsteryRestrictionResponseBody[];
  featureExclusions: ConfiguratorFeatureExclusionResponseBody[];
  previewAsConfigurator: boolean;
  includesDrafts: boolean;
};
export type ModelYearStatus = 'draft' | 'active' | 'archived';
export type CatalogueModelYearResponseBody = {
  id: string;
  name: string;
  catalogueName: string;
  vatRateType: string;
  status: ModelYearStatus;
  validFrom: string;
  validTo: string | null;
  pricelistVersionLabel: string;
};
export type CatalogueModelResponseBody = {
  id: string;
  name: string;
  imageAssetRef: string | null;
  modelYears: CatalogueModelYearResponseBody[];
};
export type CatalogueMakeResponseBody = {
  id: string;
  name: string;
  models: CatalogueModelResponseBody[];
};
export type CatalogueTreeResponseBody = {
  makes: CatalogueMakeResponseBody[];
};
export type ConfiguratorBundleResponseBody = {
  catalogueRevision: string;
  priceBasis: PriceBasis;
  currency: string;
  vatRate: MoneyDecimal;
  trims: ConfiguratorTrimResponseBody[];
  engines: ConfiguratorEngineResponseBody[];
  variants: ConfiguratorVariantResponseBody[];
  colours: ConfiguratorColourResponseBody[];
  upholsteries: ConfiguratorUpholsteryResponseBody[];
  features: ConfiguratorFeatureResponseBody[];
  packages: ConfiguratorPackageResponseBody[];
  colourUpholsteryRestrictions: ColourUpholsteryRestrictionResponseBody[];
  featureExclusions: ConfiguratorFeatureExclusionResponseBody[];
};
export type MakeResponseBody = {
  id: string;
  /** Optimistic aggregate version. Reload after a 409 stale-version response. */
  version: number;
  archived?: boolean;
  name: string;
  vehicleDataKey?: string | null;
  hsn?: string | null;
};
export type MakeWriteRequestBody = {
  name: string;
  vehicleDataKey?: string | null;
  hsn?: string | null;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
};
export type MakeListResponseBody = {
  items: MakeResponseBody[];
  total: number;
};
export type MakeOrderStatusMappingWithUsageResponseBody = {
  rawStatus: string;
  mappedStage:
    | 'ordered'
    | 'in_production'
    | 'in_transit'
    | 'arrived'
    | 'ready_for_handover'
    | 'handed_over'
    | 'cancelled';
  usageCount: number;
  lastReceivedAt: string | null;
};
export type MakeOrderStatusIntegrationResponseBody = {
  id: string;
  version: number;
};
export type MakeOrderStatusMappingResponseBody = {
  makeId: string;
  version: number;
  integration: MakeOrderStatusIntegrationResponseBody | null;
  mappings: MakeOrderStatusMappingWithUsageResponseBody[];
};
export type MakeOrderStatusSignalMappingWithUsageResponseBody = {
  rawStatus: string;
  targetKind: 'signal' | 'informational';
  mappedSignal: 'delivered' | 'cancelled' | 'retail_sold' | null;
  usageCount: number;
  lastReceivedAt: string | null;
};
export type MakeOrderStatusSignalMappingResponseBody = {
  makeId: string;
  version: number;
  integration: MakeOrderStatusIntegrationResponseBody | null;
  mappings: MakeOrderStatusSignalMappingWithUsageResponseBody[];
};
export type UnmappedMakeStatusResponseBody = {
  rawStatus: string;
  lastReceivedAt: string;
  usageCount: number;
};
export type ImageAssetRefResponseBody = {
  assetReference: string;
  source: string;
  rights: string;
  uploadedBy: string;
  fileId: string | null;
} | null;
export type ModelResponseBody = {
  id: string;
  /** Optimistic aggregate version. Reload after a 409 stale-version response. */
  version: number;
  archived?: boolean;
  makeId: string;
  name: string;
  vehicleDataKey?: string | null;
  modelFamilyGroup?: string | null;
  bodyStyle?: string | null;
  modelFamily?: string | null;
  tsn?: string | null;
  imageAssetRef?: ImageAssetRefResponseBody;
};
export type ImageAssetRefRequestBody = {
  assetReference: string;
  source: string;
  rights: string;
} | null;
export type ModelWriteRequestBody = {
  makeId: string;
  name: string;
  vehicleDataKey?: string | null;
  modelFamilyGroup?: string | null;
  /** Vehicle-catalogue `car_style` key for a passenger car, e.g. `CARSTYLE_SUV_OFFROAD`. Validated against the vehicle catalogue (unknown key 400, catalogue unavailable 503 DMS-NV-CT-0042). */
  bodyStyle?: string | null;
  modelFamily?: string | null;
  tsn?: string | null;
  imageAssetRef?: ImageAssetRefRequestBody;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
};
export type ModelListResponseBody = {
  items: ModelResponseBody[];
  total: number;
};
export type ModelYearResponseBody = {
  id: string;
  /** Optimistic aggregate version. Reload after a 409 stale-version response. */
  version: number;
  archived?: boolean;
  modelId: string;
  name: string;
  catalogueName: string;
  vatRateType: string;
  validFrom: string;
  validTo?: string | null;
  status: ModelYearStatus;
  pricelistVersionLabel: string;
  /** True when at least one configuration references this model year; Unpublish is blocked then */
  hasConfigurations: boolean;
  importerPriceList: ImporterPriceListBody;
};
/** The importer's identification of its price list; Omnetic's own label is `pricelistVersionLabel`. Dates are YYYY-MM-DD. */
export type ImporterPriceListBody = {
  /** Max 100 characters. */
  catalogueId: string | null;
  /** Importer price list version (UPP) dealers quote when ordering. Max 50 characters. */
  priceListVersion: string | null;
  /** Importer data version (PDL). Max 50 characters. */
  dataVersion: string | null;
  releasedOn: string | null;
  ordersOpenFrom: string | null;
  /** Not before `ordersOpenFrom` when both are set (400 DMS-NV-CT-0021). */
  lastOrderDate: string | null;
  /** Max 2000 characters. */
  note: string | null;
};
export type ModelYearWriteRequestBody = {
  modelId: string;
  name: string;
  catalogueName: string;
  vatRateType: 'S' | 'R' | 'MR' | 'E' | 'Z' | 'SR' | 'P';
  validFrom: string;
  validTo?: string | null;
  status: ModelYearStatus;
  pricelistVersionLabel: string;
  /** Omitted keeps the section (empty on create); an object replaces it whole, a missing key is null. 409 DMS-NV-CT-0066 when it changes while a scheduled pricelist version carries a section. */
  importerPriceList?: Partial<ImporterPriceListBody>;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
};
export type ModelYearListResponseBody = {
  items: ModelYearResponseBody[];
  total: number;
};
export type DuplicateModelYearRequestBody = {
  name: string;
  catalogueName: string;
  validFrom: string;
  validTo?: string | null;
  version: number;
};
export type ModelYearReadinessSeverity = 'blocking' | 'warning';
export type ModelYearReadinessCheckResponseBody = {
  code: string;
  label: string;
  passed: boolean;
  tab:
    | 'overview'
    | 'trim-levels'
    | 'engines'
    | 'variant-matrix'
    | 'colours'
    | 'upholstery'
    | 'features'
    | 'packages'
    | 'rules';
  severity: ModelYearReadinessSeverity;
  details: string[];
};
export type ModelYearReadinessResponseBody = {
  ready: boolean;
  checks: ModelYearReadinessCheckResponseBody[];
};
export type PublishReadinessErrorItem = {
  message: string;
  code: string;
  tab:
    | 'overview'
    | 'trim-levels'
    | 'engines'
    | 'variant-matrix'
    | 'colours'
    | 'upholstery'
    | 'features'
    | 'packages'
    | 'rules';
};
export type PublishReadinessResponseBody = {
  ready: boolean;
  errors: PublishReadinessErrorItem[];
  version: number;
};
export type PackageResponseBody = {
  id: string;
  version: number;
  archived: boolean;
  modelYearId: string;
  name: string;
  codes: string[];
  description: string;
  memberFeatureIds: string[];
  /** The trims the package is offered on, each with its price there; a package without trims is offered nowhere. */
  trims: OfferedTrimResponseBody[];
  status?: ('draft' | 'active' | 'archived' | null) | null;
};
export type PackageWriteRequestBody = {
  modelYearId: string;
  name: string;
  codes: string[];
  description: string;
  memberFeatureIds: string[];
  /** The complete set of trims the package is offered on, each with its price there; at least one. A package is offered only on the trims it lists. */
  trims: OfferedTrimRequestBody[];
  status?: ('draft' | 'active' | 'archived' | null) | null;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
  /** Required on a published model year when the write puts a row into the dealer price list or takes one out (else 409 DMS-NV-CT-0054): POST of an active package (the default) with a row on an online trim; PATCH that adds or omits a row on an online trim of an active package, or switches between draft and active. The version lists each such row as created or removed. A kept row of an active package on an online trim keeps its price also with it (409 DMS-NV-CT-0054). Ignored when the write creates and removes no such row, and on a draft model year. 409 DMS-NV-CT-0066 while a version is scheduled; 400 DMS-NV-CT-0032 for a used label. */
  pricelistVersion?: PricelistVersionRequestBody | null;
};
export type PackageListResponseBody = {
  items: PackageResponseBody[];
  total: number;
};
export type PriceAdjustmentPreviewItemResponseBody = {
  resourceType: string;
  resourceId: string;
  /** Display name of the repriced item. */
  name: string;
  before: MoneyDecimal;
  after: MoneyDecimal;
};
export type PriceAdjustmentResponseBody = {
  modelYear: ModelYearResponseBody;
  configurationsUnaffected: boolean;
  issuedOffersUnaffected: boolean;
  preview: PriceAdjustmentPreviewItemResponseBody[];
};
export type SignedDecimalInput = string;
export type PriceAdjustmentRequestBody = {
  kind: 'percentage' | 'amount' | 'set';
  value: SignedDecimalInput;
  /** `all` covers trim, variant, colour, upholstery and package prices. `feature` takes ids of features this model year uses and changes each one's trim price (`trimFeature`) on the year's non-archived trims, leaving trims that price it at 0 unchanged; a feature without an OPTIONAL assignment there changes nothing. `colour` and `package` take ids of the year's colours and packages and change each one's price on the year's non-archived trims it is offered on (`colourTrim`, `packageTrim`), likewise leaving trims that price it at 0 unchanged, as do the colour and package parts of `all`. `trimFeature`, `conditionalPrice` and `variantPriceOverride` take the `priceTargetId` values of the trim feature assignments, `colourTrim` and `packageTrim` those of the colour and package trims; a row scope also changes a price of 0. */
  scope:
    | 'all'
    | 'trim'
    | 'variant'
    | 'colour'
    | 'upholstery'
    | 'package'
    | 'feature'
    | 'trimFeature'
    | 'conditionalPrice'
    | 'variantPriceOverride'
    | 'colourTrim'
    | 'packageTrim';
  resourceIds?: string[];
  previewOnly: boolean;
  note?: string | null;
  nextPricelistVersionLabel: string;
  /** Date (YYYY-MM-DD) the prices apply from, at midnight in the tenant's time zone. Omitted or null applies them now. */
  effectiveFrom?: string | null;
  /** Omitted keeps the section; an object replaces it together with the label, now or at `effectiveFrom`. */
  importerPriceList?: Partial<ImporterPriceListBody>;
  version: number;
};
export type PricelistVersionChangeResponseBody = {
  resourceType:
    | 'trim'
    | 'variant'
    | 'colour'
    | 'upholstery'
    | 'package'
    | 'feature'
    | 'trimFeature'
    | 'conditionalPrice'
    | 'variantPriceOverride'
    | 'colourTrim'
    | 'packageTrim';
  resourceId: string;
  name: string;
  /**
   * What happened to the price. `price`: an adjustment changed its value (every entry recorded before this field
   * existed reads as `price`). `created` / `removed`: the price came into being / went away with its item.
   * `madeStandard`: `before` is the charged price as Optional, `after` is 0. `madeOptional`: the reverse.
   */
  operation: 'price' | 'created' | 'removed' | 'madeStandard' | 'madeOptional';
  /** Null when the price did not exist (`created`). Trim-level option prices of other operations than `price` are charged prices. */
  before: NullableMoneyDecimal;
  /** Null when the price no longer exists (`removed`). Trim-level option prices of other operations than `price` are charged prices. */
  after: NullableMoneyDecimal;
  /** `delta` marks a `trimFeature` change recorded before option prices were set per trim: `before` and `after` are the trim's adjustment to the library price, not the option price. Every other change has `price`. */
  priceBasis: 'price' | 'delta';
};
export type PricelistVersionHistoryItemResponseBody = {
  id: string;
  versionLabel: string;
  /**
   * `publish` is the version recorded when the model year was published; `adjustment` a price adjustment;
   * `itemChange` a create, archive/remove or inclusion switch of a priced item on a published model year (D88),
   * with null `kind` and `value`.
   */
  origin: 'publish' | 'adjustment' | 'itemChange';
  /** The adjustment rule; null on versions recorded before the history kept it. */
  kind: 'percentage' | 'amount' | 'set' | null;
  /** Signed decimal of the rule, e.g. "2.00", "-500.00"; null with `kind`. */
  value: SignedDecimalInput | null;
  effectiveFrom: string;
  /** Null while the version is scheduled and not in effect yet. */
  activatedAt: string | null;
  changedAt: string;
  changedBy: string;
  scope: string;
  configurationsUnaffected: boolean;
  note?: string | null;
  /** Null or empty for versions recorded before the history kept its price changes. */
  changes?: PricelistVersionChangeResponseBody[] | null;
  /**
   * The section this version carries: the year's at first publish, or the one the adjustment applies (at
   * once or when it takes effect); empty IDs = it clears them. Null = left as it was, or an older entry.
   */
  importerPriceList: ImporterPriceListBody | null;
};
export type PricelistVersionHistoryResponseBody = {
  items: PricelistVersionHistoryItemResponseBody[];
};
export type TrimResponseBody = {
  id: string;
  version: number;
  archived: boolean;
  modelYearId: string;
  name: string;
  codes: string[];
  bodyStyle: string;
  type?: string | null;
  basePriceNet: MoneyDecimal;
  costNet?: NullableMoneyDecimal;
  publicationStatus: PublicationStatus;
  commercialAvailability: CommercialAvailability;
  orderableFrom?: string | null;
  orderableUntil?: string | null;
};
export type TrimWriteRequestBody = {
  modelYearId: string;
  name: string;
  codes: string[];
  /** Vehicle-catalogue `car_style` key for a passenger car, e.g. `CARSTYLE_SUV_OFFROAD`. Validated against the vehicle catalogue (unknown key 400, catalogue unavailable 503 DMS-NV-CT-0042). */
  bodyStyle: string;
  type?: string | null;
  basePriceNet: MoneyInput;
  costNet?: NullableMoneyInput;
  publicationStatus: PublicationStatus;
  commercialAvailability: CommercialAvailability;
  orderableFrom?: string | null;
  orderableUntil?: string | null;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
  /** POST: required to create an online trim on a published model year (else 409 DMS-NV-CT-0054); ignored for a draft trim. PATCH: required when publicationStatus switches between draft and online on a published model year (else 409 DMS-NV-CT-0054); the version lists the base price, each enabled Variant price and each live trim feature price as added (draft to online) or removed (online to draft). PATCH without a switch ignores it. 409 DMS-NV-CT-0066 while a version is scheduled; 400 DMS-NV-CT-0032 for a used label. Ignored on a draft model year. */
  pricelistVersion?: PricelistVersionRequestBody | null;
};
export type TrimListResponseBody = {
  items: TrimResponseBody[];
  total: number;
};
export type ConditionalPriceResponseBody = {
  condition: SelectionConditionResponseBody;
  priceNet: MoneyDecimal;
  /** Read-only. The adjustment resource id of this price. */
  priceTargetId: string;
};
export type VariantPriceOverrideResponseBody = {
  variantId: string;
  priceNet: MoneyDecimal;
  /** Read-only. The adjustment resource id of this price. */
  priceTargetId: string;
};
export type TrimFeatureAssignmentResponseBody = {
  featureId: string;
  inclusion: TrimFeatureInclusion;
  appliesIf: SelectionConditionResponseBody;
  priceIf: ConditionalPriceResponseBody[];
  variantPriceOverrides: VariantPriceOverrideResponseBody[];
  /** Absolute net price of the item on this trim; null on STANDARD. */
  priceNet: NullableMoneyDecimal | null;
  costNet?: NullableMoneyDecimal;
  sortOrder: number;
  /** Read-only. Id of priceNet for a mid-year price adjustment with scope trimFeature; null on STANDARD. */
  priceTargetId: string | null;
};
export type ConditionalPriceRequestBody = {
  condition: SelectionConditionRequestBody;
  priceNet: MoneyInput;
};
export type VariantPriceOverrideRequestBody = {
  variantId: string;
  priceNet: MoneyInput;
};
export type TrimFeatureAssignmentRequestBody = {
  featureId: string;
  inclusion: TrimFeatureInclusion;
  appliesIf: SelectionConditionRequestBody;
  priceIf: ConditionalPriceRequestBody[];
  variantPriceOverrides: VariantPriceOverrideRequestBody[];
  /** Absolute net price of the item on this trim. Required for OPTIONAL (0 = free choice); null for STANDARD, which also takes no priceIf or variantPriceOverrides (400 otherwise). */
  priceNet: NullableMoneyInput;
  costNet?: NullableMoneyInput;
  sortOrder: number;
};
export type ReplaceTrimFeatureAssignmentsRequestBody = {
  assignments: TrimFeatureAssignmentRequestBody[];
  version: number;
  /** Required on a published model year when the request creates or removes a live price (an assignment, a live conditional price, a variant price override) or switches an assignment between OPTIONAL and STANDARD (else 409 DMS-NV-CT-0054). One version lists every such price. Refused when the request has no such change (400 DMS-NV-CT-0065). A changed value of a kept live price or a reorder of kept live conditional prices stays refused with 409 DMS-NV-CT-0054, also with a version. Ignored on a draft model year. */
  pricelistVersion?: PricelistVersionRequestBody | null;
};
export type ReplaceTrimUpholsteryRequestBody = {
  upholsteryIds: string[];
  version: number;
};
export type UpholsteryResponseBody = {
  id: string;
  version: number;
  archived: boolean;
  modelYearId: string;
  name: string;
  codes: string[];
  availableForTrimIds: string[];
  fabric?: string | null;
  interiorColorHex?: string | null;
  factoryCode?: string | null;
  priceNet: MoneyDecimal;
  costNet?: NullableMoneyDecimal;
};
export type UpholsteryWriteRequestBody = {
  modelYearId: string;
  name: string;
  codes: string[];
  /** Vehicle-catalogue `interior_material` key for a passenger car, e.g. `INTERIORMATERIAL_CLOTH`. Validated against the vehicle catalogue (unknown key 400, catalogue unavailable 503 DMS-NV-CT-0042). */
  fabric?: string | null;
  interiorColorHex?: string | null;
  factoryCode?: string | null;
  priceNet: MoneyInput;
  costNet?: NullableMoneyInput;
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
  /** Read only by POST; PATCH ignores it. Required to create the upholstery on a published model year (else 409 DMS-NV-CT-0054). Ignored on a draft model year. */
  pricelistVersion?: PricelistVersionRequestBody | null;
};
export type UpholsteryListResponseBody = {
  items: UpholsteryResponseBody[];
  total: number;
};
export type VariantResponseBody = {
  id: string;
  version: number;
  archived: boolean;
  trimId: string;
  engineId: string;
  priceNet: MoneyDecimal;
  costNet?: NullableMoneyDecimal;
  orderCode: string;
  enabled: boolean;
  roofHeight?: string | null;
  loadLength?: string | null;
  gvwKg?: number | null;
  payloadKg?: number | null;
  reviewFlags: ('price_unreviewed' | 'cost_unreviewed' | 'order_code_unreviewed')[];
  technicalData?: VariantTechnicalData;
};
export type VariantWriteRequestBody = {
  trimId: string;
  engineId: string;
  priceNet: MoneyInput;
  costNet?: NullableMoneyInput;
  orderCode: string;
  enabled: boolean;
  roofHeight?: string | null;
  loadLength?: string | null;
  gvwKg?: number | null;
  payloadKg?: number | null;
  reviewFlags: ('price_unreviewed' | 'cost_unreviewed' | 'order_code_unreviewed')[];
  /** Optimistic aggregate version. Required for PATCH; ignored on POST create. Reload after a 409 stale-version response. */
  version?: number | null;
  /** POST create: omitted or null stores none. PATCH and matrix cell PATCH: present replaces the whole object (null or {} clears), omitted keeps the stored value. Matrix PUT: a new cell without it stores none; an existing cell without it keeps the stored value. */
  technicalData?: VariantTechnicalData | null;
};
/** The body of POST and PATCH /variant and of PATCH /model-year/{modelYearId}/variant-matrix/{variantId}: the fields of VariantWriteRequestBody plus the price list version that a create or an `enabled` switch reads. */
export type VariantItemWriteRequestBody = VariantWriteRequestBody & {
  /** POST: required to create an enabled Variant of an online trim on a published model year (else 409 DMS-NV-CT-0054); ignored for a disabled Variant and for a Variant of a draft trim. PATCH and matrix cell PATCH: required when `enabled` switches on a Variant of an online trim on a published model year (else 409 DMS-NV-CT-0054; 409 DMS-NV-CT-0066 while a version is scheduled); the version lists the Variant price as created (enable, with the requested price) or removed (disable). A disable that also changes `priceNet` is refused with 409 DMS-NV-CT-0054. Ignored when `enabled` does not switch or the trim is draft. Ignored on a draft model year. */
  pricelistVersion?: PricelistVersionRequestBody | null;
};
export type VariantListResponseBody = {
  items: VariantResponseBody[];
  total: number;
};
export type VariantMatrixResponseBody = {
  modelYearId: string;
  version: number;
  trims: TrimResponseBody[];
  engines: EngineResponseBody[];
  cells: VariantResponseBody[];
};
export type BulkVariantUpdateScopeRequestBody = {
  trimIds?: string[];
  engineIds?: string[];
  variantIds?: string[];
};
export type BulkVariantUpdateRequestBody = {
  kind: 'percentage' | 'amount' | 'set' | 'fillDown';
  value: SignedDecimalInput;
  scope: BulkVariantUpdateScopeRequestBody;
  fields: ('priceNet' | 'costNet')[];
  clearReviewFlags: boolean;
  version: number;
};
export type VariantMatrixWriteRequestBody = {
  /** Upserted cells. Every cell carries a version: an existing cell must send its stored version (409 when stale); a new cell's version is ignored, because the top-level model year version already guards the write. */
  cells: (VariantWriteRequestBody & {
    version: number;
  })[];
  version: number;
  /** Required when the request creates an enabled cell of an online trim on a published model year, or switches `enabled` of an existing cell of an online trim (else 409 DMS-NV-CT-0054; 409 DMS-NV-CT-0066 while a version is scheduled). One version lists every created cell and every enabled Variant as created, and every disabled Variant as removed. Refused when the request creates or switches no such cell but writes an enabled cell of an online trim (400 DMS-NV-CT-0065). Ignored when the request writes only disabled cells or cells of draft trims, and on a draft model year. */
  pricelistVersion?: PricelistVersionRequestBody | null;
};
export type UuidResponseBody = {
  id: string;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchTrimCreateOperation = {
  type: 'trim.create';
  /** Optional client id of the created item. Later operations of the batch can name it (colour trims, matrix cells, package trims). Refused with DMS-NV-CT-0078 (`idTaken`) when the id is in use. */
  id?: string;
  body: TrimWriteRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. The body follows the PATCH presence rules. */
export type PricedItemBatchTrimUpdateOperation = {
  type: 'trim.update';
  /** The trim id. */
  targetId: string;
  body: TrimWriteRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchTrimArchiveOperation = {
  type: 'trim.archive';
  /** The trim id. */
  targetId: string;
  body: PricedItemArchiveRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchTrimFeatureAssignmentReplaceOperation = {
  type: 'trimFeatureAssignment.replace';
  /** The trim id. */
  targetId: string;
  body: ReplaceTrimFeatureAssignmentsRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. The model year is the one of the path. */
export type PricedItemBatchVariantMatrixPutOperation = {
  type: 'variantMatrix.put';
  body: VariantMatrixWriteRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchVariantMatrixPatchCellOperation = {
  type: 'variantMatrix.patchCell';
  /** The Variant id. */
  targetId: string;
  body: VariantItemWriteRequestBody;
};
/** It carries no price and lists no History row, so a batch of only colour creates with a top-level `pricelistVersion` is refused with DMS-NV-CT-0065. `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchColourCreateOperation = {
  type: 'colour.create';
  /** Optional client id of the created item. Later operations of the batch can name it (the colour of colourTrims.replace). Refused with DMS-NV-CT-0078 (`idTaken`) when the id is in use. */
  id?: string;
  body: ColourWriteRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchColourArchiveOperation = {
  type: 'colour.archive';
  /** The colour id. */
  targetId: string;
  body: PricedItemArchiveRequestBody;
};
/** A colour that an earlier operation of the batch creates is allowed, with `version` 1. The write lists a `colourTrim` row for each row that enters or leaves the price list. `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchColourTrimsReplaceOperation = {
  type: 'colourTrims.replace';
  /** The colour id: a stored colour of the model year, or the id of a colour.create earlier in the batch. */
  targetId: string;
  body: ReplaceColourTrimsRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchUpholsteryCreateOperation = {
  type: 'upholstery.create';
  /** Optional client id of the created item. No later operation can name it. Refused with DMS-NV-CT-0078 (`idTaken`) when the id is in use. */
  id?: string;
  body: UpholsteryWriteRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchUpholsteryArchiveOperation = {
  type: 'upholstery.archive';
  /** The upholstery id. */
  targetId: string;
  body: PricedItemArchiveRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchPackageCreateOperation = {
  type: 'package.create';
  /** Optional client id of the created item. No later operation can name it. Refused with DMS-NV-CT-0078 (`idTaken`) when the id is in use. */
  id?: string;
  body: PackageWriteRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. The body follows the PATCH presence rules. */
export type PricedItemBatchPackageUpdateOperation = {
  type: 'package.update';
  /** The package id. */
  targetId: string;
  body: PackageWriteRequestBody;
};
/** `pricelistVersion` inside `body` is refused with DMS-NV-CT-0078 (`pricelistVersionInOperation`). Send it once, at the top level of the batch. */
export type PricedItemBatchPackageArchiveOperation = {
  type: 'package.archive';
  /** The package id. */
  targetId: string;
  body: PricedItemArchiveRequestBody;
};
/** Updates the library feature targetId, as PATCH /dms/v1/new-vehicle/catalogue/feature/{featureId} does. Allowed only for a member of a package that the batch creates or updates, and only for `standaloneOrderable` (`DMS-NV-CT-0078`, `featureNotInPackage`, `featureFieldChanged`). The write records no price list row. */
export type PricedItemBatchFeatureUpdateOperation = {
  type: 'feature.update';
  /** The library feature id. */
  targetId: string;
  body: FeatureWriteRequestBody;
};
/** One write of a batch, discriminated on `type`. The creates and `variantMatrix.put` carry no `targetId`; every other type requires it. */
export type PricedItemBatchOperation =
  | PricedItemBatchTrimCreateOperation
  | PricedItemBatchTrimUpdateOperation
  | PricedItemBatchTrimArchiveOperation
  | PricedItemBatchTrimFeatureAssignmentReplaceOperation
  | PricedItemBatchVariantMatrixPutOperation
  | PricedItemBatchVariantMatrixPatchCellOperation
  | PricedItemBatchColourCreateOperation
  | PricedItemBatchColourArchiveOperation
  | PricedItemBatchColourTrimsReplaceOperation
  | PricedItemBatchUpholsteryCreateOperation
  | PricedItemBatchUpholsteryArchiveOperation
  | PricedItemBatchPackageCreateOperation
  | PricedItemBatchPackageUpdateOperation
  | PricedItemBatchPackageArchiveOperation
  | PricedItemBatchFeatureUpdateOperation;
/** Several item writes of one model year in one transaction, with at most one new price list version (D107). The operations run in array order; the first failure writes nothing. */
export type PricedItemChangeBatchRequestBody = {
  /** Required on a published model year when an operation creates or removes a price list item (else 409 DMS-NV-CT-0054). Sent when no operation creates or removes a price list row: 400 DMS-NV-CT-0065. 409 DMS-NV-CT-0066 while a version is scheduled. Ignored on a draft model year. */
  pricelistVersion?: PricelistVersionRequestBody | null;
  /** 1 to 100 operations. */
  operations: PricedItemBatchOperation[];
};
export type PricedItemChangeBatchOperationResponseBody = {
  index: number;
  type: PricedItemBatchOperation['type'];
  /** The created id for a create, the path model year for `variantMatrix.put`, else `targetId`. */
  resourceId: string;
};
export type PricedItemChangeBatchResponseBody = {
  /** The recorded version. Null on a draft model year, or when the request has no pricelistVersion. A batch with a pricelistVersion but no price list row is refused with 400 DMS-NV-CT-0065. */
  pricelistVersion: {
    id: string;
    label: string;
  } | null;
  /** The model year version after the commit. */
  modelYearVersion: number;
  /** One item per operation, in request order. */
  operations: PricedItemChangeBatchOperationResponseBody[];
};
export type CopyConfigurationRequestBody = {
  label?: string;
};
export type ConfigurationSelection = {
  modelYearId: string;
  trimId: string;
  variantId: string;
  colourId?: string | null;
  upholsteryId?: string | null;
  /** Selection order is not significant. The evaluator normalizes feature IDs deterministically; when selected features exclude each other, every conflicting selected feature is invalidated regardless of input order. */
  featureIds: string[];
  packageIds: string[];
};
export type TypedAnyValue = object;
export type FieldValue = {
  definitionId: string;
  value: TypedAnyValue;
};
export type CreateConfigurationRequestBody = {
  label: string;
  selection: ConfigurationSelection;
  catalogueRevision: string;
  customerId?: string | null;
  interestId?: string | null;
  businessCaseId?: string | null;
  customFields?: FieldValue[];
  proposedDiscount?: ProposedDiscount | null;
};
export type ConfigurationResponseBody = {
  id: string;
  branchId: string;
  customerId: string | null;
  interestId: string | null;
  businessCaseId: string | null;
  vehicleId: string | null;
  label: string;
  selection: ConfigurationSelection;
  customFields: FieldValue[];
  createdBy: string;
  createdAt: string;
  copiedFromId: string | null;
  version: number;
  notSelected: boolean;
};
export type PriceSnapshotLineResponseBody = {
  type: string;
  id: string;
  label: string;
  factoryCode: string | null;
  unitNet: MoneyDecimal;
  unitGross: MoneyDecimal;
  costNet?: NullableMoneyDecimal | null;
  bundleSavingsNet?: NullableMoneyDecimal | null;
};
export type PriceSnapshotResponseBody = {
  schemaVersion: number;
  catalogueRevision: string;
  frozenAt: string;
  priceValidUntil: string | null;
  currency: string;
  vatRateType: string;
  vatRate: MoneyDecimal;
  lines: PriceSnapshotLineResponseBody[];
  listTotalNet: MoneyDecimal;
  listTotalGross: MoneyDecimal;
  proposedDiscount: ProposedDiscount | null;
  proposedSellingPriceNet: NullableMoneyDecimal | null;
  proposedSellingPriceGross: NullableMoneyDecimal | null;
  totalNet: MoneyDecimal;
  vat: MoneyDecimal;
  totalGross: MoneyDecimal;
  totalCostNet?: NullableMoneyDecimal | null;
  /** The price list the snapshot was priced on; null on snapshots saved before it was recorded. */
  priceList: PriceSnapshotPriceListResponseBody | null;
};
export type PriceSnapshotPriceListResponseBody = {
  pricelistVersionLabel: string;
  importerCatalogueId: string | null;
  importerPriceListVersion: string | null;
};
export type VehicleOrderSource = 'customer' | 'stock' | 'external';
export type VehicleOrderStatus =
  | 'ordered'
  | 'in_production'
  | 'in_transit'
  | 'arrived'
  | 'ready_for_handover'
  | 'handed_over'
  | 'cancelled';
export type OrderStatusLogEntryResponseBody = {
  at: string;
  actor: string | null;
  kind: 'manual' | 'integration';
  rawStatus: string | null;
  mappedStage:
    | (
        | 'ordered'
        | 'in_production'
        | 'in_transit'
        | 'arrived'
        | 'ready_for_handover'
        | 'handed_over'
        | 'cancelled'
      )
    | null;
  note: string | null;
  targetKind?: ('stage' | 'signal' | 'informational' | 'unmapped') | null;
  mappedSignal?: ('delivered' | 'cancelled' | 'retail_sold') | null;
  statusDescription?: string | null;
  factoryRecordedAt?: string | null;
  receivedByDmsAt?: string | null;
  facts?: OrderStatusLogFactsResponseBody | null;
  holdChange?: ('set' | 'released') | null;
  orderVersionChanged?: boolean | null;
};
export type OrderStatusLogFactsResponseBody = {
  vin: string | null;
  engineNumber: string | null;
  plannedBuildDate: string | null;
  scheduledBuildDate: string | null;
  estimatedDeliveryDate: string | null;
  gateReleaseDate: string | null;
  dealerDeliveryDate: string | null;
  factoryOrderId: string | null;
  orderVersion: string | null;
  cancelled: boolean | null;
  contract: boolean | null;
  hold: boolean | null;
  holdReason: string | null;
  holdExpectedReleaseDate: string | null;
};
export type ConfigurationOrderSummaryResponseBody = {
  id: string;
  source: VehicleOrderSource;
  status: VehicleOrderStatus;
  importerOrderRef: string | null;
  orderedOn: string | null;
  eta: string | null;
  specFreezeDate: string | null;
  cancellationReason: string | null;
  latestStatusLog: OrderStatusLogEntryResponseBody[];
};
export type ConfigurationVehicleLinkResponseBody = {
  vehicleId: string;
  saleVehicleId: string;
  vin: string | null;
  incoming: boolean;
};
export type ConfigurationDetailResponseBody = {
  configuration: ConfigurationResponseBody;
  currentPriceSnapshot: PriceSnapshotResponseBody;
  priceValidity: 'valid' | 'expired';
  catalogueChanged: boolean;
  order: ConfigurationOrderSummaryResponseBody | null;
  vehicle: ConfigurationVehicleLinkResponseBody | null;
};
export type UpdateConfigurationRequestBody = {
  label: string;
  selection: ConfigurationSelection;
  catalogueRevision: string;
  version: number;
  customFields?: FieldValue[];
  proposedDiscount?: ProposedDiscount | null;
};
export type EvaluateConfigurationRequestBody = {
  modelYearId: string;
  trimId: string;
  variantId: string;
  colourId?: string | null;
  upholsteryId?: string | null;
  /** Selection order is not significant. The evaluator normalizes feature IDs deterministically; when selected features exclude each other, every conflicting selected feature is invalidated regardless of input order. */
  featureIds: string[];
  packageIds: string[];
  proposedDiscount?: ProposedDiscount | null;
};
export type ExportConfigurationOfferSheetRequestBody = {
  /** Optional document template identifier. The default template is used when omitted. */
  templateId?: string | null;
};
export type ConfigurationCustomerViewLineResponseBody = {
  type: string;
  id: string;
  label: string;
  unitGross: MoneyDecimal;
};
export type ConfigurationCustomerViewCodeResponseBody = {
  label: string;
  code: string;
};
export type ConfigurationCustomerViewResponseBody = {
  label: string;
  validityDate: string | null;
  disclaimer: string;
  currency: string;
  lines: ConfigurationCustomerViewLineResponseBody[];
  listTotalNet: MoneyDecimal;
  listTotalGross: MoneyDecimal;
  discount: ProposedDiscount | null;
  vat: MoneyDecimal;
  totalGross: MoneyDecimal;
  proposedSellingNet: NullableMoneyDecimal | null;
  proposedSellingGross: NullableMoneyDecimal | null;
  codes: ConfigurationCustomerViewCodeResponseBody[];
};
export type InterestConfigurationListItemResponseBody = {
  id: string;
  label: string;
  modelYear: string;
  trim: string;
  variant: string;
  totalGross: MoneyDecimal;
  currency: string;
  priceValidity: 'valid' | 'expired';
  vehicleId: string | null;
  businessCaseId: string | null;
  orderStatus:
    | (
        | 'ordered'
        | 'in_production'
        | 'in_transit'
        | 'arrived'
        | 'ready_for_handover'
        | 'handed_over'
        | 'cancelled'
      )
    | null;
  createdAt: string;
  notSelected: boolean;
  /** Whether a physical arrival record exists, including after order cancellation. False when there is no order. */
  hasArrived: boolean;
};
export type RepriceConfigurationRequestBody = {
  catalogueRevision: string;
  version: number;
};
export type ConfigurationDiffItemResponseBody = {
  path: string;
  orderedValue: ((string[] | null) | (string | null)) | null;
  observedValue: ((string[] | null) | (string | null)) | null;
};
export type ConfigurationDiffResponseBody = {
  changed: boolean;
  items: ConfigurationDiffItemResponseBody[];
};
export type ArrivalDetailResponseBody = {
  arrivedOn: string;
  vin: string | null;
  note: string | null;
  diff: ConfigurationDiffResponseBody;
};
export type VehicleOrderFactoryRecordResponseBody = {
  record: {
    [key: string]: any;
  } | null;
};
export type VehicleOrderDetailResponseBody = {
  id: string;
  configurationId: string;
  vehicleId: string;
  saleVehicleId: string | null;
  source: VehicleOrderSource;
  status: VehicleOrderStatus;
  importerOrderRef: string | null;
  orderedOn: string | null;
  eta: string | null;
  specFreezeDate: string | null;
  cancellationReason: string | null;
  rawStatus: string | null;
  mappedStage: VehicleOrderStatus | null;
  importerDiverges: boolean;
  /** @deprecated Always null; read the record with getVehicleOrderFactoryRecord. */
  integrationData: {
    [key: string]: any;
  } | null;
  hasFactoryRecord: boolean;
  statusLog: OrderStatusLogEntryResponseBody[];
  arrival: ArrivalDetailResponseBody | null;
  version: number;
  factoryStatusDescription?: string | null;
  factoryRecordedAt?: string | null;
  receivedByDmsAt?: string | null;
  plannedBuildDate?: string | null;
  scheduledBuildDate?: string | null;
  gateReleaseDate?: string | null;
  dealerDeliveryDate?: string | null;
  factoryOrderId?: string | null;
  factoryOrderVersion?: string | null;
  awaitingConfirmation?: VehicleOrderAwaitingConfirmationResponseBody | null;
  vinConflict?: VehicleOrderVinConflictResponseBody | null;
  factoryHold?: VehicleOrderFactoryHoldResponseBody | null;
  vehicleVin?: string | null;
};
export type VehicleOrderAwaitingConfirmationResponseBody = {
  kind: 'delivered' | 'cancelled';
  since: string;
};
export type VehicleOrderVinConflictResponseBody = {
  value: string;
  since: string;
};
export type VehicleOrderFactoryHoldResponseBody = {
  reason: string | null;
  expectedReleaseDate: string | null;
};
export type ImporterStatusRequestBody = {
  source: string;
  sourceEventId: string;
  rawStatus: string;
  receivedAt: string;
  payload?: {
    [key: string]: any;
  } | null;
};
export type CancelOrderRequestBody = {
  reason: string;
  version: number;
};
export type ChangeFactoryReferenceRequestBody = {
  /** Stored trimmed; null or blank clears it. Unique per make among orders that are not cancelled. */
  importerOrderRef: string | null;
  version: number;
};
export type CommitConfigurationResponseBody = {
  vehicleId: string;
  vehicleOrderId: string;
};
export type CommitConfigurationToBusinessCaseRequestBody = {
  businessCaseId: string;
  version: number;
  catalogueRevision: string;
  /** Atomically replace the current selection; additionally requires Business Case change-vehicle permission. */
  replaceSaleVehicle?: boolean;
  /** Required when replaceSaleVehicle is true (omitting it is rejected with 400): the observed current SaleVehicle ID, or explicit null for an observed empty Business Case. A changed selection returns 409. Ignored otherwise. */
  expectedSaleVehicleId?: string | null;
  /** Factory reference (dealer order number in the factory system). Unique per make among orders that are not cancelled, compared after trimming and upper-casing. Max 255 characters. */
  importerOrderRef?: string | null;
};
export type HandoverRequestBody = {
  version: number;
  note?: string | null;
};
export type MaterializationResponseBody = {
  id: string;
  vehicleId: string;
  saleVehicleId: string;
};
export type OrderConfigurationRequestBody = {
  riskConfirmed: boolean;
  version: number;
  importerOrderRef?: string | null;
  orderedOn?: string | null;
  eta?: string | null;
  specFreezeDate?: string | null;
};
export type ArrivalRequestBody = {
  version: number;
  vin?: string | null;
  observedSpec?: ConfigurationSelection | null;
  note?: string | null;
};
export type RegisterExternalOrderRequestBody = {
  orderedOn: string;
  version: number;
  importerOrderRef?: string | null;
  eta?: string | null;
  stage?: VehicleOrderStatus | null;
  vin?: string | null;
  note?: string | null;
};
export type UpdateOrderStatusRequestBody = {
  status: VehicleOrderStatus;
  version: number;
  note?: string | null;
};
export const {
  useArchiveColourMutation,
  useGetColourQuery,
  useUpdateColourMutation,
  useCreateColourMutation,
  useListColourQuery,
  usePutColourTrimsMutation,
  useGetColourUpholsteryRestrictionsQuery,
  usePutColourUpholsteryRestrictionsMutation,
  useArchiveEngineMutation,
  useGetEngineQuery,
  useUpdateEngineMutation,
  useCreateEngineMutation,
  useListEngineQuery,
  useEvaluateAuthorConfigurationQuery,
  useArchiveFeatureMutation,
  useGetFeatureQuery,
  useUpdateFeatureMutation,
  useCreateFeatureMutation,
  useListFeatureQuery,
  useCreateFeatureRuleMutation,
  useListFeatureRuleQuery,
  useDeleteFeatureRuleMutation,
  useGetFeatureRuleQuery,
  useUpdateFeatureRuleMutation,
  useGetAuthorConfiguratorBundleQuery,
  useGetCatalogueTreeQuery,
  useGetConfiguratorBundleQuery,
  useArchiveMakeMutation,
  useGetMakeQuery,
  useUpdateMakeMutation,
  useCreateMakeMutation,
  useListMakeQuery,
  useGetMakeOrderStatusMappingQuery,
  useGetMakeOrderStatusSignalMappingQuery,
  useListUnmappedMakeStatusQuery,
  useArchiveModelMutation,
  useGetModelQuery,
  useUpdateModelMutation,
  useCreateModelMutation,
  useListModelQuery,
  useUploadModelImageMutation,
  useArchiveModelYearMutation,
  useGetModelYearQuery,
  useUpdateModelYearMutation,
  useCreateModelYearMutation,
  useListModelYearQuery,
  useDuplicateModelYearMutation,
  useGetModelYearReadinessQuery,
  usePublishModelYearMutation,
  useUnpublishModelYearMutation,
  useArchivePackageMutation,
  useGetPackageQuery,
  useUpdatePackageMutation,
  useCreatePackageMutation,
  useListPackageQuery,
  useApplyMidYearPriceAdjustmentMutation,
  useApplyPricedItemChangeBatchMutation,
  useListPricelistVersionHistoryQuery,
  useCancelPricelistVersionMutation,
  useArchiveTrimMutation,
  useGetTrimQuery,
  useUpdateTrimMutation,
  useCreateTrimMutation,
  useListTrimQuery,
  useListTrimFeatureAssignmentsQuery,
  usePutTrimFeatureAssignmentsMutation,
  usePutTrimUpholsteryMutation,
  useArchiveUpholsteryMutation,
  useGetUpholsteryQuery,
  useUpdateUpholsteryMutation,
  useCreateUpholsteryMutation,
  useListUpholsteryQuery,
  useArchiveVariantMutation,
  useGetVariantQuery,
  useUpdateVariantMutation,
  useCreateVariantMutation,
  useListVariantQuery,
  useBulkUpdateVariantMatrixMutation,
  useGetVariantMatrixQuery,
  usePutVariantMatrixMutation,
  usePatchVariantMatrixCellMutation,
  useCopyConfigurationMutation,
  useCreateConfigurationMutation,
  useDeleteConfigurationMutation,
  useGetConfigurationDetailQuery,
  useUpdateConfigurationMutation,
  useEvaluateConfigurationQuery,
  useExportConfigurationOfferSheetMutation,
  useGetConfigurationByVehicleQuery,
  useGetConfigurationCustomerViewQuery,
  useListBusinessCaseConfigurationsQuery,
  useListInterestConfigurationsQuery,
  useRepriceConfigurationMutation,
  useApplyImporterStatusMutation,
  useCancelOrderMutation,
  useChangeFactoryReferenceMutation,
  useCommitConfigurationToBusinessCaseMutation,
  useGetVehicleOrderQuery,
  useGetVehicleOrderFactoryRecordQuery,
  useHandoverOrderMutation,
  useOrderConfigurationMutation,
  useRecordOrderArrivalMutation,
  useRegisterExternalOrderMutation,
  useUpdateOrderStatusMutation,
} = injectedRtkApi;
